import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import * as lottie from 'lottie-web'
import * as dat from 'lil-gui'
const TWEEN = require('@tweenjs/tween.js')

//Lottie Animations
var animation = lottie.loadAnimation({
  container: document.getElementById('LoadingIcon'),
  path: 'https://assets5.lottiefiles.com/packages/lf20_6bt3w7ru.json',
  renderer: 'svg',
  loop: true,
  autoplay: true,
  name: "Loading Icon",
})

// console.log()
//window.alert()
//debug panel
const gui = new dat.GUI()
// var guiParams = {
//     // color: 0xffffff,
//     // pointLightIntencity: 0.9,
//     // directionalLightIntencity: 8,
//     // ambientLightIntencity: 0.4,
//     // distance: 1,
//     // pointLight1HelperVisible: false
    // fov: 50
// };
// gui.add(guiParams, 'fov', 20, 100, 1).name("field of view")
// gui.add(guiParams, 'pointLightIntencity', 0, 10, 0.05).name("Point Light")
// gui.addColor(guiParams, 'color').name('PS5 Color')
// gui.add(guiParams, 'directionalLightIntencity', 0, 20, 0.05).name("Light Intencity")
// gui.add(guiParams, 'ambientLightIntencity', 0, 10, 0.05).name("Ambient Light")
// gui.add(guiParams, 'distance', 0, 5, 0.05).name("Point Light Distance")
// gui.add(guiParams, 'pointLight1HelperVisible').name("PointLightHelper Visible")
gui.hide()

// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color(0xB5C4C4)

//Canvas
var canvas = document.querySelector('canvas.webgl')
// Sizes
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

//Resize the window 
window.addEventListener('resize', () =>
{
    screenResizeHandler()
})
window.addEventListener("orientationchange", (event) => 
{
    screenResizeHandler()
    if(window.orientation != 0)
    {
        screenResizeHandler()
    }
})


// Camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height)
camera.position.x = 1.8
camera.position.y = 0.3
camera.position.z = 0
scene.add(camera)

// Renderer

var renderer = new THREE.WebGLRenderer({ canvas: canvas, preserveDrawingBuffer: true})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio( window.devicePixelRatio )
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.render(scene, camera)


//Axes Helper
// const axesHelper = new THREE.AxesHelper(4)
// scene.add(axesHelper)
// gui.add(axesHelper, 'visible').name("AxisHelper")

//Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.dampingFactor = 0.04
controls.enablePan = false
// controls.enableZoom = false
//when tween set to default to prevent several bugs and return when u exit the tweens
controls.minPolarAngle = Math.PI/3
controls.maxPolarAngle = Math.PI/2
controls.minAzimuthAngle = Infinity
controls.maxAzimuthAngle = Infinity
controls.maxDistance = 1.8
controls.minDistance = 1.2

// controls.enabled = false
//controls.target

//PS5 Controls Event Listeners
var startTouchPos
var currentTouchPos

canvas.addEventListener('mousemove', onMouseMove);
canvas.addEventListener('touchmove', onTouchMove);
addEventListener("touchstart", (event) => 
{
    // console.log(event)
    startTouchPos = event.changedTouches[0].pageX
})

//Light
const ambientLight = new THREE.AmbientLight(0xffffff, 0.1)
scene.add(ambientLight)

// const directionalLight1 = new THREE.DirectionalLight( 0xffffff, 2 )
// directionalLight1.position.set( 10, 10, 7.5 );
// scene.add(directionalLight1)

const directionalLight1 = new THREE.DirectionalLight( 0xffffff, 3.2 )
directionalLight1.position.set( 5, 10, 7.5 );
scene.add(directionalLight1)

const directionalLight2 = new THREE.DirectionalLight( 0xffffff, 3.2 )
directionalLight2.position.set( 5, 10, -7.5 );
scene.add(directionalLight2)

const directionalLight5 = new THREE.DirectionalLight( 0xffffff, -1 )
directionalLight5.position.set( 0, 100, 0 );
scene.add(directionalLight5)

const directionalLight51 = new THREE.DirectionalLight( 0xffffff, 1 )
directionalLight51.position.set( 0, -100, 0 );
scene.add(directionalLight51)

const directionalLight6 = new THREE.DirectionalLight( 0x585858, 4 )
directionalLight6.position.set( -10, 0, 0 );
scene.add(directionalLight6)

// const helper = new THREE.DirectionalLightHelper( directionalLight1, 0.2 );
// scene.add( helper );

//SMAA
const composer = new EffectComposer( renderer )
const renderPass = new RenderPass( scene, camera )
composer.addPass( renderPass )
const smaaPass = new SMAAPass( window.innerWidth * renderer.getPixelRatio(), window.innerHeight * renderer.getPixelRatio() )
smaaPass.enabled = true
composer.addPass( smaaPass )
// gui.add(smaaPass, 'enabled').name("SMAA")
    
    //PC parts
    //case
    var case1
    var case2
    var case3
    var case4
    var case5
    var case6
    var caseTemp
    var caseType = 0
    //GPU
    var gpu1
    var gpu2
    var gpu3
    var gpuTemp
    var gpuType = 0
    //MB
    var mb1
    var mb2
    var mb3
    var mb4
    var mb5
    var mbTemp
    var mbType = 0
    //CPU Cooling
    var cpuC1
    var cpuC2
    var cpuC3
    var cpuCTemp
    var cpuType = 0
    //RAM
    var ram1
    var ram1clone1
    var ram1clone2
    var ram1clone3
    var ram2
    var ram2clone1
    var ram2clone2
    var ram2clone3
    var ramTemp
    var ramTempclone1
    var ramTempclone2
    var ramTempclone3

    //Accessories
    //Chair
    var chair1
    var chair2
    var chair2Handler = false
    var chair3
    var chair4
    var chairTemp
    var chairParts = []
    //Screen
    var screen1
    var screen2
    var screen3
    var screen4
    var screenTemp
    var screenParts = []
    //Keyboard
    var keyboard1
    var keyboard2
    var keyboard3
    var keyboard4
    var keyboardTemp
    //Mouse
    var mouse1
    var mouse2
    var mouse3
    var mouse4
    var mouseTemp
    //Mousepad
    var mousepad1
    var mousepad2
    var mousepad3
    var mousepad4
    var mousepadTemp

    //rooms
    var room1
    
    //PS5
    var ps5
    var ps5loaded = false
    var ps5pressed = false
    var ps5buttonPressed = false

    //id's
    var idCase = "a"
    var idGpu = "a"
    var idMb = "a"
    var idCpuC = "a"
    var idRam = "a"
    var idPb = "a"
    var idCpu = "a"
    var idSsd1 = "a"
    var idSsd2 = "a"
    var idHdd1 = "a"
    var idHdd2 = "a"
    var idChair = "a"
    var idScreen = "a"
    var idKeyboard = "a"
    var idMouse = "a"
    var idMousepad = "a"

    const abcArray = ' abcdefghijklmnopqrstuvwxyz'.split('')
    //id = idCase + idGpu + idMb + idCpuC + idRam + idChair + idScreen + idKeyboard + idMouse + idMousepad
    //man-made.ru/3dconfig/?id=aaaaaaaaaa

//URL handler
const url = new URL(window.location)
if(url.searchParams.get('id') === null)
{
    url.searchParams.set('id', "aaaaaaaaaaaaaaaa")
}
// console.log(url.searchParams.get('id'))
// url.searchParams.set('id', 'aaaaaaaaaaaaaaaa')
window.history.pushState({}, '', url)
var idStringArray = url.searchParams.get('id').split('')

customIdHandler()



//Loading
const loadingManager = new THREE.LoadingManager()
loadingManager.onProgress = function ( url, itemsLoaded, itemsTotal ) 
{   
    //console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    var progressRatio = itemsLoaded / itemsTotal * 100
    document.getElementById("loadingNumber").innerHTML = Math.round(progressRatio) + "%"
    screenResizeHandler()
}
loadingManager.onLoad = function ( url, itemsLoaded, itemsTotal )
{
    postLoadingHandler()
    screenResizeHandler()
    document.getElementById("loadingScreen").style.display = "none"
}

// let objCastShadow, objReceiveShadow
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('/draco/')
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

    //Models Loading Functions
    caseLoader()
    gpuLoader()
    mbLoader()
    cpuCLoader()
    ramLoader()

    chairLoader()
    screenLoader()
    keyboardLoader()
    mouseLoader()
    mousepadLoader()

    roomLoader()



////////////////////
const dir = new THREE.Vector3( 0, 0, 0 )

//normalize the direction vector (convert to vector of length 1)
dir.normalize()

const origin1 = new THREE.Vector3(1.1,-0.8,2.17)
const origin2 = new THREE.Vector3(-1.84,-0.71,0.15)
const length = 0
const hex = 0xffff00

//const arrowhelper = new THREE.ArrowHelper( dir, origin1, length, hex )
// scene.add( arrowhelper )
/////////////////////

//Camera animation with TWEEN.js
var cameraStartPos = new THREE.Vector3().copy(camera.position)  //start camera position backup

//Points of interest
const points = 
[
    {
        //pc
        position: new THREE.Vector3( -1.1,-0.71,0.19 ),
        element: document.querySelector('.point-1')
    },
    {
        //ps5
        position: new THREE.Vector3( -1.52,-1.1,-2.4 ),
        element: document.querySelector('.point-0')
    },
    {
        //case
        position: new THREE.Vector3( -1.65,-0.45,-0.65 ),
        element: document.querySelector('.point-2')
    },
    {
        //16bit
        position: new THREE.Vector3( -1.33,0.216,3.54 ),
        element: document.querySelector('.point-3')
    },
    {
        //torpedo
        position: new THREE.Vector3( -0.9,-0.147,-3.63 ),
        element: document.querySelector('.point-4')
    }
]
// ps5
document.getElementById("button0").onclick = function() {buttonsForCameraAnimation(-0.3, -0.1, -2.6, 0, -1.5, -0.6, -2.6)}//camera, point to look at
// pc
document.getElementById("button1").onclick = function() {buttonsForCameraAnimation(0.9,0.1,1.3, 1, -1.81,-0.8,0.1)}
// case
document.getElementById("button2").onclick = function() {buttonsForCameraAnimation(-1.65,-0.2,0.2, 2, -1.65,-0.45,-0.65)}
// to pc from case
document.getElementById("backButton2").onclick = function() {buttonsForCameraAnimation(0.9,0.1,1.3, 3, -1.81,-0.8,0.1)}
//16bit
document.getElementById("button3").onclick = function() {buttonsForCameraAnimation(-0.5,0.216,2.5, 4, -1.33,0.216,3.54)}
//torpedo
document.getElementById("button4").onclick = function() {buttonsForCameraAnimation(-1.3,-0.147,-2.2, 5, -0.5,-0.147,-3.63)}


var button0Pressed = false
var button1Pressed = false
var button2Pressed = false
var button3Pressed = false
var button4Pressed = false
var button5Pressed = false
document.getElementById("backButton0").onclick = function() {buttonsForBackCameraAnimation(cameraStartPos.x, cameraStartPos.y, cameraStartPos.z, 0)}
document.getElementById("backButton1").onclick = function() {buttonsForBackCameraAnimation(cameraStartPos.x, cameraStartPos.y, cameraStartPos.z, 1)}
document.getElementById("backButton3").onclick = function() {buttonsForBackCameraAnimation(cameraStartPos.x, cameraStartPos.y, cameraStartPos.z, 4)}
document.getElementById("backButton4").onclick = function() {buttonsForBackCameraAnimation(cameraStartPos.x, cameraStartPos.y, cameraStartPos.z, 5)}
var backButtonPressed = false

//switching models buttons
//pc parts
document.getElementById("caseButton1").onclick = function() {configButtonsHandler(case2,caseTemp, "case",2, "b", "Jonsbo Jonsplus i400-G Silver", 1)}
document.getElementById("caseButton2").onclick = function() {configButtonsHandler(case1,caseTemp, "case",0, "a", "Powercase MISTRAL Micro T3B CMIMTB-L3", 2)}
document.getElementById("caseButton3").onclick = function() {configButtonsHandler(case3,caseTemp, "case",0, "c", "1stPlayer INFINITE SPACE IS6", 3)}
document.getElementById("caseButton4").onclick = function() {configButtonsHandler(case5,caseTemp, "case",2, "e", "MagniumGear NEO Qube 2 Infinity Mirror", 4)}
document.getElementById("caseButton5").onclick = function() {configButtonsHandler(case4,caseTemp, "case",1, "d", "Fractal Design Torrent Black RGB TG", 5)}
document.getElementById("caseButton6").onclick = function() {configButtonsHandler(case6,caseTemp, "case",2, "f", "Phanteks Eclipse P500A", 6)}

document.getElementById("mbButton1").onclick = function() {configButtonsHandler(mb3,mbTemp, "mb", 4, "c", "ASUS ROG MAXIMUS Z790 EXTREME", 1)}
document.getElementById("mbButton2").onclick = function() {configButtonsHandler(mb2,mbTemp, "mb", 4, "b", "ASUS PRIME Z790-A WIFI", 2)}
document.getElementById("mbButton3").onclick = function() {configButtonsHandler(mb5,mbTemp, "mb", 4, "e", "GIGABYTE Z790 AORUS MASTER", 3)}
document.getElementById("mbButton4").onclick = function() {configButtonsHandler(mb4,mbTemp, "mb", 4, "d", "GIGABYTE Z790 AERO G", 4)}
document.getElementById("mbButton5").onclick = function() {configButtonsHandler(mb1,mbTemp, "mb", 3, "a", "ASROCK B660M PRO RS", 5)}

document.getElementById("gpuButton1").onclick = function() {configButtonsHandler(gpu3,gpuTemp, "gpu", -1, "c", "Palit GeForce RTX 4090 GameRock", 1)}
document.getElementById("gpuButton2").onclick = function() {configButtonsHandler(gpu2,gpuTemp, "gpu", -1, "b", "ASUS TUF Gaming GeForce RTX® 4080", 2)}
document.getElementById("gpuButton3").onclick = function() {configButtonsHandler(gpu1,gpuTemp, "gpu", -1, "a", "NVIDIA RTX 3060 Ti FE", 3)}

document.getElementById("cpuCButton1").onclick = function() {configButtonsHandler(cpuC3,cpuCTemp, "cpuC", -1, "c", "NZXT Kraken Z63 RGB", 1)}
document.getElementById("cpuCButton2").onclick = function() {configButtonsHandler(cpuC2,cpuCTemp, "cpuC", -1, "b", "Fractal Design Lumen S24", 2)}
document.getElementById("cpuCButton3").onclick = function() {configButtonsHandler(cpuC1,cpuCTemp, "cpuC", -1, "a", "Alseye M120D PLUS (II)", 3)}

document.getElementById("ramButton1x2").onclick = function() {ramButtonsHandler(ram2, ram2clone1, ram2clone2, ram2clone3, ramTemp, ramTempclone1, ramTempclone2, ramTempclone3, 2, "c", "Kingston 8Gb DDR4 2400MHz", 1)}
document.getElementById("ramButton1x4").onclick = function() {ramButtonsHandler(ram2, ram2clone1, ram2clone2, ram2clone3, ramTemp, ramTempclone1, ramTempclone2, ramTempclone3, 4, "d", "Kingston 16Gb DDR4 3466MHz Kingston", 2)}
document.getElementById("ramButton2x2").onclick = function() {ramButtonsHandler(ram1, ram1clone1, ram1clone2, ram1clone3, ramTemp, ramTempclone1, ramTempclone2, ramTempclone3, 2, "a", "tforceDelta 8Gb DDR4 3200MHz", 3)}
document.getElementById("ramButton2x4").onclick = function() {ramButtonsHandler(ram1, ram1clone1, ram1clone2, ram1clone3, ramTemp, ramTempclone1, ramTempclone2, ramTempclone3, 4, "b", "tforceDelta 16Gb DDR4 3200MHz", 4)}

for(let a = 1; a < 14; a++)
{
    document.getElementById("pbButton" + a).onclick = function() {temporaryPcPartsFunc("pb", document.getElementById("pbButton" + a).parentNode.parentNode.innerText, a)}
}
for(let a = 1; a < 11; a++)
{
    document.getElementById("cpuButton" + a).onclick = function() {temporaryPcPartsFunc("cpu", document.getElementById("cpuButton" + a).parentNode.parentNode.innerText, a)}
}
for(let a = 1; a < 14; a++)
{
    document.getElementById("ssd1Button" + a).onclick = function() {temporaryPcPartsFunc("ssd1", document.getElementById("ssd1Button" + a).parentNode.parentNode.innerText, a)}
}
for(let a = 1; a < 14; a++)
{
    document.getElementById("ssd2Button" + a).onclick = function() {temporaryPcPartsFunc("ssd2", document.getElementById("ssd2Button" + a).parentNode.parentNode.innerText, a)}
}
for(let a = 1; a < 16; a++)
{
    document.getElementById("hdd1Button" + a).onclick = function() {temporaryPcPartsFunc("hdd1", document.getElementById("hdd1Button" + a).parentNode.parentNode.innerText, a)}
}
for(let a = 1; a < 16; a++)
{
    document.getElementById("hdd2Button" + a).onclick = function() {temporaryPcPartsFunc("hdd2", document.getElementById("hdd2Button" + a).parentNode.parentNode.innerText, a)}
}
// childElementCount

//accessories
document.getElementById("screenButton1").onclick = function() {accessoriesButtonsHandler(screen1,screenTemp, "screen", "a", "Не выбрано", 1)}
document.getElementById("screenButton2").onclick = function() {accessoriesButtonsHandler(screen1,screenTemp, "screen", "b", "ACER CB342CKCsmiiphuzx 34", 2)}
document.getElementById("screenButton3").onclick = function() {accessoriesButtonsHandler(screen2,screenTemp, "screen", "c", "AOC Gaming 24G2SU 23.8", 3)}
document.getElementById("screenButton4").onclick = function() {accessoriesButtonsHandler(screen3,screenTemp, "screen", "d", "ASUS ROG Swift PG32UQX 32", 4)}
document.getElementById("screenButton5").onclick = function() {accessoriesButtonsHandler(screen4,screenTemp, "screen", "e", "Samsung Odyssey G9 C49G95TSSR 49", 5)}

document.getElementById("keyboardButton1").onclick = function() {accessoriesButtonsHandler(keyboard1,keyboardTemp, "keyboard", "a", "Не выбрано", 1)}
document.getElementById("keyboardButton2").onclick = function() {accessoriesButtonsHandler(keyboard1,keyboardTemp, "keyboard", "b", "AKKO 3084B Plus Jelly", 2)}
document.getElementById("keyboardButton3").onclick = function() {accessoriesButtonsHandler(keyboard2,keyboardTemp, "keyboard", "c", "Logitech G915 TKL", 3)}
document.getElementById("keyboardButton4").onclick = function() {accessoriesButtonsHandler(keyboard3,keyboardTemp, "keyboard", "d", "Logitech G PRO", 4)}
document.getElementById("keyboardButton5").onclick = function() {accessoriesButtonsHandler(keyboard4,keyboardTemp, "keyboard", "e", "Razer BlackWidow V3 Pro", 5)}

document.getElementById("mouseButton1").onclick = function() {accessoriesButtonsHandler(mouse1,mouseTemp, "mouse", "a", "Не выбрано", 1)}
document.getElementById("mouseButton2").onclick = function() {accessoriesButtonsHandler(mouse1,mouseTemp, "mouse", "b", "Logitech PRO Х Superlight Wireless", 2)}
document.getElementById("mouseButton3").onclick = function() {accessoriesButtonsHandler(mouse2,mouseTemp, "mouse", "c", "Microsoft Intellimouse Classic", 3)}
document.getElementById("mouseButton4").onclick = function() {accessoriesButtonsHandler(mouse3,mouseTemp, "mouse", "d", "Xtrfy M4 RGB", 4)}
document.getElementById("mouseButton5").onclick = function() {accessoriesButtonsHandler(mouse4,mouseTemp, "mouse", "e", "Razer Basilisk Ultimate", 5)}

document.getElementById("mousepadButton1").onclick = function() {accessoriesButtonsHandler(mousepad1,mousepadTemp, "mousepad", "a", "Не выбрано", 1)}
document.getElementById("mousepadButton2").onclick = function() {accessoriesButtonsHandler(mousepad1,mousepadTemp, "mousepad", "b", "Cooler Master Gaming Masteraccessory MP750 Size M", 2)}
document.getElementById("mousepadButton3").onclick = function() {accessoriesButtonsHandler(mousepad2,mousepadTemp, "mousepad", "c", "Cooler Master XL Size", 3)}
document.getElementById("mousepadButton4").onclick = function() {accessoriesButtonsHandler(mousepad3,mousepadTemp, "mousepad", "d", "Razer Goliathus Extended Chroma", 4)}
document.getElementById("mousepadButton5").onclick = function() {accessoriesButtonsHandler(mousepad4,mousepadTemp, "mousepad", "e", "Razer Strider Chroma", 5)}

document.getElementById("chairButton1").onclick = function() {accessoriesButtonsHandler(chair1,chairTemp, "chair", "a", "Не выбрано", 1)}
document.getElementById("chairButton2").onclick = function() {accessoriesButtonsHandler(chair1,chairTemp, "chair", "b", "Cooler Master Caliber R2", 2)}
document.getElementById("chairButton3").onclick = function() {accessoriesButtonsHandler(chair2,chairTemp, "chair", "c", "ASUS ROG Chariot Gaming Chair RGB", 3)}
document.getElementById("chairButton4").onclick = function() {accessoriesButtonsHandler(chair3,chairTemp, "chair", "d", "Noblechairs ICON", 4)}

//header buttons
//fullscreen
var fullScreen3DconfigOn = false
document.getElementById("fullScreen3Dconfig").onclick = function() {fullScreen()}
//screenshot
document.getElementById("screenshot3Dconfig").onclick = function() {screenshot()}
document.getElementById("screenshot3DPanelSaveImg").onclick = function() {saveScreenshot()}
document.getElementById("screenshot3DPanelCloseId").onclick = function() {closePanel("screenshot3DPanelId")}
document.getElementById("reset3Dconfig").onclick = function() {configSetDefault()}
document.getElementById("compatibility3Dconfig").onclick = function() {compatibilityTurnOn()}

camera.updateMatrix()
camera.updateMatrixWorld()
camera.matrixWorldInverse.getInverse( camera.matrixWorld )
var frustum = new THREE.Frustum()

//var for camera.lookAt animation
var cameraLookAt = new THREE.Vector3( 0, 0, 0 )

var partsHandlingDone = false
var compatibilityCaseHandlingDone = true
var compatibilityMbHandlingDone = true
var urlHandlingDone = false
var cpuCHandlingDone = false

var chairIsTransparentWhile360Camera = false

//Update function
function animate()
{
    controls.update()
    //pointsOptimization()
    //Buttons in scene handler 
    for(const point of points)
    {
        frustum.setFromProjectionMatrix( new THREE.Matrix4().multiplyMatrices( camera.projectionMatrix, camera.matrixWorldInverse ) )
        if(frustum.containsPoint(point.position) === false)
        {
            point.element.classList.remove('visible')
        }
        else if(frustum.containsPoint(point.position) === true)
        {
            // Get 2D screen position
            const screenPosition = point.position.clone()
            screenPosition.project(camera)
    
            point.element.classList.add('visible')

            const translateX = screenPosition.x * sizes.width * 0.5
            const translateY = - screenPosition.y * sizes.height * 0.5
            point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }  
    }

    //chair handler
    if(button1Pressed === false && button2Pressed === false)
    {
        if( frustum.containsPoint(new THREE.Vector3( -2, -0.3, -3.5 )) === false && 
        frustum.containsPoint(new THREE.Vector3( -2, -0.3, 0    )) === false && 
        frustum.containsPoint(new THREE.Vector3( -1.6, -0.3, 3.5  )) === false)
        {
            chairIsTransparentWhile360Camera = true
            for(let i = 0; i < chairParts.length; i++)
            {
                chairTemp.getObjectByName(chairParts[i]).material.transparent = true
                chairTemp.getObjectByName(chairParts[i]).material.opacity = 0.08
            }
        }
        else
        {
            chairIsTransparentWhile360Camera = false
            for(let i = 0; i < chairParts.length; i++)
            {
                // chairTemp.getObjectByName(chairParts[i]).material.transparent = false
                chairTemp.getObjectByName(chairParts[i]).material.opacity = 1
            }
        }
    }
    

    //PS5 handler
    if(ps5loaded === true && ps5pressed === false && ps5buttonPressed === true)
    {
        room1.getObjectByName( 'Plane014' ).material.color = new THREE.Color(document.querySelector("#colorWell").value)
        canvas.addEventListener('mousedown', (e) => 
        {
            let log = document.querySelector('#log');
            switch (e.button) 
            {
                case 0:
                    ps5pressed = true;
                    break
                default:
                    ps5pressed = false;
            }
        });
    }
    if(ps5loaded === true && ps5pressed === true && ps5buttonPressed === true)
    {
        room1.getObjectByName( 'Plane014' ).material.color = new THREE.Color(document.querySelector("#colorWell").value)
        window.addEventListener('mouseup', (e) => 
        {
            let log = document.querySelector('#log');
            switch (e.button) 
            {
                case 0:
                    ps5pressed = false;
                    break
                default:
                    ps5pressed = false;
            }
        });
    }

    //pc parts pos handler
    if(mbTemp != null && gpuTemp != null && cpuCTemp != null && partsHandlingDone === false && caseTemp != null && ramTemp != null)
    {
        var posMB1
        var posMB2
        posMB1 = caseTemp.getObjectByName('PcMBpoint').getWorldPosition(new THREE.Vector3(0,0,0))
        posMB2 = mbTemp.getObjectByName('MBpoint').getWorldPosition(new THREE.Vector3(0,0,0))
        var posMB3 = new THREE.Vector3(posMB1.x - posMB2.x, posMB1.y - posMB2.y,posMB1.z - posMB2.z)
        mbTemp.position.set(mbTemp.position.x + posMB3.x, mbTemp.position.y + posMB3.y, mbTemp.position.z + posMB3.z)

        var pos1
        var pos2
        pos1 = mbTemp.getObjectByName('MbGPUpoint').getWorldPosition(new THREE.Vector3(0,0,0))
        pos2 = gpuTemp.getObjectByName('GPUpoint').getWorldPosition(new THREE.Vector3(0,0,0))
        var pos3 = new THREE.Vector3(pos1.x - pos2.x, pos1.y - pos2.y,pos1.z - pos2.z)
        gpuTemp.position.set(gpuTemp.position.x + pos3.x, gpuTemp.position.y + pos3.y, gpuTemp.position.z + pos3.z)

        var posCPUc1
        var posCPUc2
        var posCPUw1
        var posCPUw2
        if(cpuCTemp.children[1] === undefined)
        {
            posCPUc1 = mbTemp.getObjectByName('CPUcMBpoint').getWorldPosition(new THREE.Vector3(0,0,0))
            posCPUc2 = cpuCTemp.getObjectByName('cpuCpoint').getWorldPosition(new THREE.Vector3(0,0,0))
            var posCPUc3 = new THREE.Vector3(posCPUc1.x - posCPUc2.x, posCPUc1.y - posCPUc2.y,posCPUc1.z - posCPUc2.z)
            cpuCTemp.position.set(cpuCTemp.position.x + posCPUc3.x, cpuCTemp.position.y + posCPUc3.y, cpuCTemp.position.z + posCPUc3.z)
        }
        else if(cpuCTemp.children[1] != undefined)
        {
            posCPUc1 = mbTemp.getObjectByName('CPUcMBpoint').getWorldPosition(new THREE.Vector3(0,0,0))
            posCPUc2 = cpuCTemp.children[0].getObjectByName('cpuCpoint').getWorldPosition(new THREE.Vector3(0,0,0))
            var posCPUc3 = new THREE.Vector3(posCPUc1.x - posCPUc2.x, posCPUc1.y - posCPUc2.y,posCPUc1.z - posCPUc2.z)
            cpuCTemp.children[0].position.set(cpuCTemp.children[0].position.x + posCPUc3.x, cpuCTemp.children[0].position.y + posCPUc3.y, cpuCTemp.children[0].position.z + posCPUc3.z)

            if(caseTemp.getObjectByName('CPUcCASEpoint') != undefined)
            {
                posCPUw1 = caseTemp.getObjectByName('CPUcCASEpoint').getWorldPosition(new THREE.Vector3(0,0,0))
                posCPUw2 = cpuCTemp.children[1].getObjectByName('CPUcPCpoint').getWorldPosition(new THREE.Vector3(0,0,0))
                var posCPUw3 = new THREE.Vector3(posCPUw1.x - posCPUw2.x, posCPUw1.y - posCPUw2.y,posCPUw1.z - posCPUw2.z)
                cpuCTemp.children[1].position.set(cpuCTemp.children[1].position.x + posCPUw3.x, cpuCTemp.children[1].position.y + posCPUw3.y, cpuCTemp.children[1].position.z + posCPUw3.z)
            }
        }

        var posRamMB1
        var posRamMB2
        var posRamMBclone1
        var posRamMBclone2
        var posRamMBclone3

        posRamMB1 = mbTemp.getObjectByName('ram1').getWorldPosition(new THREE.Vector3(0,0,0))
        posRamMB2 = ramTemp.getObjectByName('ramMbpoint').getWorldPosition(new THREE.Vector3(0,0,0))
        var posRamMB3 = new THREE.Vector3(posRamMB1.x - posRamMB2.x, posRamMB1.y - posRamMB2.y,posRamMB1.z - posRamMB2.z)
        ramTemp.position.set(ramTemp.position.x + posRamMB3.x, ramTemp.position.y + posRamMB3.y, ramTemp.position.z + posRamMB3.z)

        posRamMBclone1 = mbTemp.getObjectByName('ram2').getWorldPosition(new THREE.Vector3(0,0,0))
        posRamMBclone2 = ramTempclone1.getObjectByName('ramMbpoint').getWorldPosition(new THREE.Vector3(0,0,0))
        posRamMBclone3 = new THREE.Vector3(posRamMBclone1.x - posRamMBclone2.x, posRamMBclone1.y - posRamMBclone2.y,posRamMBclone1.z - posRamMBclone2.z)
        ramTempclone1.position.set(ramTempclone1.position.x + posRamMBclone3.x, ramTempclone1.position.y + posRamMBclone3.y, ramTempclone1.position.z + posRamMBclone3.z)

        posRamMBclone1 = mbTemp.getObjectByName('ram3').getWorldPosition(new THREE.Vector3(0,0,0))
        posRamMBclone2 = ramTempclone2.getObjectByName('ramMbpoint').getWorldPosition(new THREE.Vector3(0,0,0))
        posRamMBclone3 = new THREE.Vector3(posRamMBclone1.x - posRamMBclone2.x, posRamMBclone1.y - posRamMBclone2.y,posRamMBclone1.z - posRamMBclone2.z)
        ramTempclone2.position.set(ramTempclone2.position.x + posRamMBclone3.x, ramTempclone2.position.y + posRamMBclone3.y, ramTempclone2.position.z + posRamMBclone3.z)

        posRamMBclone1 = mbTemp.getObjectByName('ram4').getWorldPosition(new THREE.Vector3(0,0,0))
        posRamMBclone2 = ramTempclone3.getObjectByName('ramMbpoint').getWorldPosition(new THREE.Vector3(0,0,0))
        posRamMBclone3 = new THREE.Vector3(posRamMBclone1.x - posRamMBclone2.x, posRamMBclone1.y - posRamMBclone2.y,posRamMBclone1.z - posRamMBclone2.z)
        ramTempclone3.position.set(ramTempclone3.position.x + posRamMBclone3.x, ramTempclone3.position.y + posRamMBclone3.y, ramTempclone3.position.z + posRamMBclone3.z)

        partsHandlingDone = true
    }

    //case compatibility handling
    // if(compatibilityCaseHandlingDone === false && mbTemp != null && gpuTemp != null && cpuCTemp != null && caseTemp != null && ramTemp != null)
    // {
    //     if(caseType === 0)
    //     {
    //         //mb
    //         // document.getElementById("mbButton1panel").style.display = "block"
    //         // document.getElementById("mbButton2panel").style.display = "block"
    //         // document.getElementById("mbButton3panel").style.display = "block"
    //         // document.getElementById("mbButton4panel").style.display = "block"
    //         //gpu
    //         // document.getElementById("gpuButton1panel").style.display = "block"
    //         // document.getElementById("gpuButton2panel").style.display = "block"
    //         //cpuC
    //         // document.getElementById("cpuCButton1panel").style.display = "block"
    //         // document.getElementById("cpuCButton2panel").style.display = "block"
    //         //default parts
    //         //mb
    //         scene.remove(mbTemp)
    //         scene.add(mb1)
    //         mbTemp = mb1
    //         //gpu
    //         scene.remove(gpuTemp)
    //         scene.add(gpu1)
    //         gpuTemp = gpu1
    //         //cpuC
    //         scene.remove(cpuCTemp)
    //         scene.add(cpuC1)
    //         cpuCTemp = cpuC1
    //         partsHandlingDone = false
    //         document.getElementById("currentConfigMb").innerHTML = "ASROCK B660M PRO RS"
    //         document.getElementById("currentConfigGpu").innerHTML = "NVIDIA RTX 3060 Ti FE"
    //         document.getElementById("currentConfigCpuC").innerHTML = "Alseye M120D PLUS (II)"

    //         for(let a = 1; a < 14; a++)
    //         {
    //             // document.getElementById("s2PB").children[a].children[1].style.display = "block"
    //             // document.getElementById("pbButton" + a + "panel").style.display = "block"
    //         }
    //         // document.getElementById("pbButton1panel").style.display = "none"
    //         // document.getElementById("pbButton4panel").style.display = "none"
    //         // document.getElementById("pbButton6panel").style.display = "none"
    //         // document.getElementById("pbButton12panel").style.display = "none"

    //         if(document.getElementById("currentConfigPb").innerHTML != document.getElementById("pbButton1").parentNode.parentNode.innerText.replace(" добавлено", "")  &&
    //            document.getElementById("currentConfigPb").innerHTML != document.getElementById("pbButton4").parentNode.parentNode.innerText.replace(" добавлено", "")  &&
    //            document.getElementById("currentConfigPb").innerHTML != document.getElementById("pbButton6").parentNode.parentNode.innerText.replace(" добавлено", "")  &&
    //            document.getElementById("currentConfigPb").innerHTML != document.getElementById("pbButton12").parentNode.parentNode.innerText.replace(" добавлено", "") )

    //         {
    //             document.getElementById("currentConfigPb").innerHTML = document.getElementById("pbButton1").parentNode.parentNode.innerText.replace(" добавлено", "").replace(" Добавить", "")
    //         }
    //         document.getElementById("mbButton1").disabled = false
    //         document.getElementById("mbButton2").disabled = false
    //         document.getElementById("mbButton3").disabled = false
    //         document.getElementById("mbButton4").disabled = false
    //         document.getElementById("mbButton5").disabled = true
    //         document.getElementById("mbButton1").innerHTML = "Добавить"
    //         document.getElementById("mbButton2").innerHTML = "Добавить"
    //         document.getElementById("mbButton3").innerHTML = "Добавить"
    //         document.getElementById("mbButton4").innerHTML = "Добавить"
    //         document.getElementById("mbButton5").innerHTML = "добавлено"

    //         document.getElementById("gpuButton1").disabled = false
    //         document.getElementById("gpuButton2").disabled = false
    //         document.getElementById("gpuButton3").disabled = true
    //         document.getElementById("gpuButton1").innerHTML = "Добавить"
    //         document.getElementById("gpuButton2").innerHTML = "Добавить"
    //         document.getElementById("gpuButton3").innerHTML = "добавлено"

    //         document.getElementById("cpuCButton1").disabled = false
    //         document.getElementById("cpuCButton2").disabled = false
    //         document.getElementById("cpuCButton3").disabled = true
    //         document.getElementById("cpuCButton1").innerHTML = "Добавить"
    //         document.getElementById("cpuCButton2").innerHTML = "Добавить"
    //         document.getElementById("cpuCButton3").innerHTML = "добавлено"

    //         for(let a = 1; a < 14; a++)
    //         {
    //             document.getElementById("pbButton" + a).disabled = false
    //             document.getElementById("pbButton" + a).innerHTML = "Добавить"
    //         }
    //         document.getElementById("pbButton1").disabled = true
    //         document.getElementById("pbButton1").innerHTML = "добавлено"
    //         document.getElementById("currentConfigPb").innerHTML = document.getElementById("pbButton1").parentNode.parentNode.innerText.replace(" добавлено", "")

    //     }
    //     else if(caseType === 1)
    //     {
    //         //mb
    //         // document.getElementById("mbButton1panel").style.display = "none"
    //         // document.getElementById("mbButton2panel").style.display = "none"
    //         // document.getElementById("mbButton3panel").style.display = "none"
    //         // document.getElementById("mbButton4panel").style.display = "none"
    //         //gpu
    //         // document.getElementById("gpuButton1panel").style.display = "none"
    //         // document.getElementById("gpuButton2panel").style.display = "none"
    //         //cpuC
    //         // document.getElementById("cpuCButton1panel").style.display = "block"
    //         // document.getElementById("cpuCButton2panel").style.display = "block"
    //         //default parts
    //         //cpuC
    //         scene.remove(cpuCTemp)
    //         scene.add(cpuC1)
    //         cpuCTemp = cpuC1
    //         partsHandlingDone = false
    //         document.getElementById("currentConfigCpuC").innerHTML = "Alseye M120D PLUS (II)"

    //         for(let a = 1; a < 14; a++)
    //         {
    //             // document.getElementById("s2PB").children[a].children[1].style.display = "none"
    //             // document.getElementById("pbButton" + a + "panel").style.display = "none"
    //         }
    //         document.getElementById("cpuCButton1").disabled = false
    //         document.getElementById("cpuCButton2").disabled = false
    //         document.getElementById("cpuCButton3").disabled = true
    //         document.getElementById("cpuCButton1").innerHTML = "Добавить"
    //         document.getElementById("cpuCButton2").innerHTML = "Добавить"
    //         document.getElementById("cpuCButton3").innerHTML = "добавлено"
    //     }
    //     else if(caseType === 2)
    //     {
    //         //mb
    //         // document.getElementById("mbButton1panel").style.display = "none"
    //         // document.getElementById("mbButton2panel").style.display = "none"
    //         // document.getElementById("mbButton3panel").style.display = "none"
    //         // document.getElementById("mbButton4panel").style.display = "none"
    //         // //gpu
    //         // document.getElementById("gpuButton1panel").style.display = "none"
    //         // document.getElementById("gpuButton2panel").style.display = "none"
    //         // //cpuC
    //         // document.getElementById("cpuCButton1panel").style.display = "none"
    //         // document.getElementById("cpuCButton2panel").style.display = "none"

    //         for(let a = 1; a < 14; a++)
    //         {
    //             // document.getElementById("s2PB").children[a].children[1].style.display = "none"
    //             // document.getElementById("pbButton" + a + "panel").style.display = "none"
    //         }
    //     }
    //     compatibilityCaseHandlingDone = true
    // }

    //mb and cpu compatibility handling

    // if(compatibilityMbHandlingDone === false && mbTemp != null)
    // {
    //     switch(mbType)
    //     {
    //         case 0:
    //         for(let a = 1; a < 11; a++)
    //         {
    //             // document.getElementById("s2CP").children[a].children[1].style.display = "block"
    //             // document.getElementById("cpuButton" + a + "panel").style.display = "block"
    //         }
    //         // document.getElementById("cpuButton1panel").style.display = "none"
    //         // document.getElementById("cpuButton2panel").style.display = "none"
    //         for(let a = 1; a < 11; a++)
    //         {
    //             document.getElementById("cpuButton" + a).disabled = false
    //             document.getElementById("cpuButton" + a).innerHTML = "Добавить"
    //         }
    //         document.getElementById("cpuButton1").disabled = true
    //         document.getElementById("cpuButton1").innerHTML = "добавлено"
    //         document.getElementById("currentConfigCPU").innerHTML = document.getElementById("cpuButton1").parentNode.parentNode.innerText.replace(" добавлено", "")

    //         break;

    //         case 1:
    //         for(let a = 1; a < 11; a++)
    //         {
    //             // document.getElementById("s2CP").children[a].children[1].style.display = "none"
    //             // document.getElementById("cpuButton" + a + "panel").style.display = "none"
    //         }
    //         document.getElementById("currentConfigCPU").innerHTML = document.getElementById("cpuButton1").parentNode.parentNode.innerText.replace(" добавлено", "")

    //         break;
    //     }
    //     compatibilityMbHandlingDone = true
    // }

    //cpuC vertical/horizontal handler
    if(cpuCHandlingDone === false && cpuCTemp != null && caseTemp != null)
    {
        if(caseTemp === case4)
        {
            // cpuC3.children[1].rotation.x = -1.57
            // cpuC3.children[1].rotation.y = -1.57

            // cpuC2.children[1].rotation.x = -1.57
            // cpuC2.children[1].rotation.y = -1.57
            document.getElementById("cpuCButton1").disabled = false
            document.getElementById("cpuCButton2").disabled = false
            document.getElementById("cpuCButton3").disabled = true
            document.getElementById("cpuCButton1").innerHTML = "Добавить"
            document.getElementById("cpuCButton2").innerHTML = "Добавить"
            document.getElementById("cpuCButton3").innerHTML = "добавлено"
            document.getElementById("currentConfigCpuC").innerHTML = "Alseye M120D PLUS (II)"
            document.getElementById("cpuCButton1panel").style.display = "block"
            document.getElementById("cpuCButton2panel").style.display = "block"
            scene.remove(cpuCTemp)
            scene.add(cpuC1)
            cpuCTemp = cpuC1
        }
        else
        {
            // cpuC3.children[1].rotation.x = 0
            // cpuC3.children[1].rotation.y = 0

            // cpuC2.children[1].rotation.x = 0
            // cpuC2.children[1].rotation.y = 0
            document.getElementById("cpuCButton1panel").style.display = "none"
            document.getElementById("cpuCButton2panel").style.display = "none"
        }
        cpuCHandlingDone = true
        partsHandlingDone = false
    }

    //new compatibility handler
    if(compatibilityCaseHandlingDone === false && mbTemp != null && gpuTemp != null && cpuCTemp != null && caseTemp != null && ramTemp != null)
    {
        if(gpuType === 0 && cpuType === 0)
        {
            //change pb to random compatible one
            for(let a = 1; a < 14; a++)
            {
                document.getElementById("pbButton" + a).disabled = false
                document.getElementById("pbButton" + a).innerHTML = "Добавить"
            }
            var pbArray = [1, 4, 6, 12]
            var randomPb = pbArray[Math.floor(Math.random() * 3)]
            document.getElementById("pbButton" + randomPb).disabled = true
            document.getElementById("pbButton" + randomPb).innerHTML = "добавлено"
            document.getElementById("currentConfigPb").innerHTML = document.getElementById("pbButton" + randomPb).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigPb").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigPb").classList.remove("mm-3d-box-anim")
            },1000)
            idPb = abcArray[randomPb]
            //change case to random compatible one
            for(let a = 1; a < 7; a++)
            {
                document.getElementById("caseButton" + a).disabled = false
                document.getElementById("caseButton" + a).innerHTML = "Добавить"
            }
            var randomCase = Math.floor(Math.random() * 6) + 1
            document.getElementById("caseButton" + randomCase).disabled = true
            document.getElementById("caseButton" + randomCase).innerHTML = "добавлено"
            document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton" + randomCase).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigCase").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigCase").classList.remove("mm-3d-box-anim")
            },1000)
            scene.remove(caseTemp)
            if(randomCase === 2)
            {
                scene.add(case1)
                caseTemp = case1
                idCase = abcArray[1]
            }
            else if(randomCase === 1)
            {
                scene.add(case2)
                caseTemp = case2
                idCase = abcArray[2]
            }
            else if(randomCase === 3)
            {
                scene.add(case3)
                caseTemp = case3
                idCase = abcArray[3]
            }
            else if(randomCase === 5)
            {
                scene.add(case4)
                caseTemp = case4
                idCase = abcArray[4]
            }
            else if(randomCase === 4)
            {
                scene.add(case5)
                caseTemp = case5
                idCase = abcArray[5]
            }
            else if(randomCase === 6)
            {
                scene.add(case6)
                caseTemp = case6
                idCase = abcArray[6]
            }
            //change mb
            for(let a = 1; a < 6; a++)
            {
                document.getElementById("mbButton" + a).disabled = false
                document.getElementById("mbButton" + a).innerHTML = "Добавить"
            }
            document.getElementById("mbButton5").disabled = true
            document.getElementById("mbButton5").innerHTML = "добавлено"
            document.getElementById("currentConfigMb").innerHTML = document.getElementById("mbButton5").parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigMb").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigMb").classList.remove("mm-3d-box-anim")
            },1000)
            scene.remove(mbTemp)
            scene.add(mb1)
            mbTemp = mb1
            idMb = abcArray[1]
        }
        else if(gpuType === 0 && cpuType === 1)
        {
            //change pb to random compatible one
            for(let a = 1; a < 14; a++)
            {
                document.getElementById("pbButton" + a).disabled = false
                document.getElementById("pbButton" + a).innerHTML = "Добавить"
            }
            var pbArray = [1, 4, 6, 12]
            var randomPb = pbArray[Math.floor(Math.random() * 3)]
            document.getElementById("pbButton" + randomPb).disabled = true
            document.getElementById("pbButton" + randomPb).innerHTML = "добавлено"
            document.getElementById("currentConfigPb").innerHTML = document.getElementById("pbButton" + randomPb).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigPb").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigPb").classList.remove("mm-3d-box-anim")
            },1000)
            idPb = abcArray[randomPb]
            //change case to random compatible one
            for(let a = 1; a < 7; a++)
            {
                document.getElementById("caseButton" + a).disabled = false
                document.getElementById("caseButton" + a).innerHTML = "Добавить"
            }
            var caseArray = [1, 4, 5, 6]
            var randomCase = caseArray[Math.floor(Math.random() * 4)]
            document.getElementById("caseButton" + randomCase).disabled = true
            document.getElementById("caseButton" + randomCase).innerHTML = "добавлено"
            document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton" + randomCase).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigCase").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigCase").classList.remove("mm-3d-box-anim")
            },1000)
            scene.remove(caseTemp)
            if(randomCase === 1)
            {
                scene.add(case2)
                caseTemp = case2
                idCase = abcArray[2]
            }
            else if(randomCase === 4)
            {
                scene.add(case5)
                caseTemp = case5
                idCase = abcArray[5]
            }
            else if(randomCase === 5)
            {
                scene.add(case4)
                caseTemp = case4
                idCase = abcArray[4]
            }
            else if(randomCase === 6)
            {
                scene.add(case6)
                caseTemp = case6
                idCase = abcArray[6]
            }
            //change mb to random compatible one
            for(let a = 1; a < 6; a++)
            {
                document.getElementById("mbButton" + a).disabled = false
                document.getElementById("mbButton" + a).innerHTML = "Добавить"
            }
            var randomMb = Math.floor(Math.random() * 4) + 1
            document.getElementById("mbButton" + randomMb).disabled = true
            document.getElementById("mbButton" + randomMb).innerHTML = "добавлено"
            document.getElementById("currentConfigMb").innerHTML = document.getElementById("mbButton" + randomMb).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigMb").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigMb").classList.remove("mm-3d-box-anim")
            },1000)
            scene.remove(mbTemp)
            if(randomMb === 1)
            {
                scene.add(mb3)
                mbTemp = mb3
                idMb = abcArray[3]
            }
            else if(randomMb === 2)
            {
                scene.add(mb2)
                mbTemp = mb2
                idMb = abcArray[2]
            }
            else if(randomMb === 3)
            {
                scene.add(mb5)
                mbTemp = mb5
                idMb = abcArray[5]
            }
            else if(randomMb === 4)
            {
                scene.add(mb4)
                mbTemp = mb4
                idMb = abcArray[4]
            }
        }
        else if(gpuType === 1 && cpuType === 0 || gpuType === 1 && cpuType === 1)
        {
            //change pb to random compatible one
            for(let a = 1; a < 14; a++)
            {
                document.getElementById("pbButton" + a).disabled = false
                document.getElementById("pbButton" + a).innerHTML = "Добавить"
            }
            var pbArray = [2, 3, 5, 7, 8, 9, 10, 11, 13]
            var randomPb = pbArray[Math.floor(Math.random() * 9)]
            document.getElementById("pbButton" + randomPb).disabled = true
            document.getElementById("pbButton" + randomPb).innerHTML = "добавлено"
            document.getElementById("currentConfigPb").innerHTML = document.getElementById("pbButton" + randomPb).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigPb").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigPb").classList.remove("mm-3d-box-anim")
            },1000)
            idPb = abcArray[randomPb]
            //change case to random compatible one
            for(let a = 1; a < 7; a++)
            {
                document.getElementById("caseButton" + a).disabled = false
                document.getElementById("caseButton" + a).innerHTML = "Добавить"
            }
            var caseArray = [1, 4, 5, 6]
            var randomCase = caseArray[Math.floor(Math.random() * 4)]
            document.getElementById("caseButton" + randomCase).disabled = true
            document.getElementById("caseButton" + randomCase).innerHTML = "добавлено"
            document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton" + randomCase).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigCase").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigCase").classList.remove("mm-3d-box-anim")
            },1000)
            scene.remove(caseTemp)
            if(randomCase === 1)
            {
                scene.add(case2)
                caseTemp = case2
                idCase = abcArray[2]
            }
            else if(randomCase === 4)
            {
                scene.add(case5)
                caseTemp = case5
                idCase = abcArray[5]
            }
            else if(randomCase === 5)
            {
                scene.add(case4)
                caseTemp = case4
                idCase = abcArray[4]
            }
            else if(randomCase === 6)
            {
                scene.add(case6)
                caseTemp = case6
                idCase = abcArray[6]
            }
            //change mb to random compatible one
            for(let a = 1; a < 6; a++)
            {
                document.getElementById("mbButton" + a).disabled = false
                document.getElementById("mbButton" + a).innerHTML = "Добавить"
            }
            var randomMb = Math.floor(Math.random() * 4) + 1
            document.getElementById("mbButton" + randomMb).disabled = true
            document.getElementById("mbButton" + randomMb).innerHTML = "добавлено"
            document.getElementById("currentConfigMb").innerHTML = document.getElementById("mbButton" + randomMb).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigMb").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigMb").classList.remove("mm-3d-box-anim")
            },1000)
            scene.remove(mbTemp)
            if(randomMb === 1)
            {
                scene.add(mb3)
                mbTemp = mb3
                idMb = abcArray[3]
            }
            else if(randomMb === 2)
            {
                scene.add(mb2)
                mbTemp = mb2
                idMb = abcArray[2]
            }
            else if(randomMb === 3)
            {
                scene.add(mb5)
                mbTemp = mb5
                idMb = abcArray[5]
            }
            else if(randomMb === 4)
            {
                scene.add(mb4)
                mbTemp = mb4
                idMb = abcArray[4]
            }
            //change cpu to random compatible one
            for(let a = 1; a < 11; a++)
            {
                document.getElementById("cpuButton" + a).disabled = false
                document.getElementById("cpuButton" + a).innerHTML = "Добавить"
            }
            var cpuArray = [5, 6, 7, 8, 9, 10]
            var randomCpu = cpuArray[Math.floor(Math.random() * 6)]
            document.getElementById("cpuButton" + randomCpu).disabled = true
            document.getElementById("cpuButton" + randomCpu).innerHTML = "добавлено"
            document.getElementById("currentConfigCPU").innerHTML = document.getElementById("cpuButton" + randomCpu).parentNode.parentNode.innerText.replace(" добавлено", "")
            document.getElementById("currentConfigCPU").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigCPU").classList.remove("mm-3d-box-anim")
            },1000)
            idCpu = abcArray[randomCpu]
        }
        if(caseTemp === case1 || caseTemp === case3 || caseTemp === case4)
        {
            for(let a = 1; a < 4; a++)
            {
                document.getElementById("cpuCButton" + a).disabled = false
                document.getElementById("cpuCButton" + a).innerHTML = "Добавить"
            }
            document.getElementById("cpuCButton3").disabled = true
            document.getElementById("cpuCButton3").innerHTML = "добавлено"
            document.getElementById("currentConfigCpuC").innerHTML = "Alseye M120D PLUS (II)"
            document.getElementById("currentConfigCpuC").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigCpuC").classList.remove("mm-3d-box-anim")
            },1000)
            scene.remove(cpuCTemp)
            scene.add(cpuC1)
            cpuCTemp = cpuC1
            idCpuC = abcArray[1]
        }
        else if(caseTemp === case2 || caseTemp === case5 || caseTemp === case6)
        {
            for(let a = 1; a < 4; a++)
            {
                document.getElementById("cpuCButton" + a).disabled = false
                document.getElementById("cpuCButton" + a).innerHTML = "Добавить"
            }
            var randomCpuC = Math.floor(Math.random() * 3) + 1
            
            document.getElementById("currentConfigCpuC").classList.add("mm-3d-box-anim")
            setTimeout(() => {
                document.getElementById("currentConfigCpuC").classList.remove("mm-3d-box-anim")
            },1000)
            scene.remove(cpuCTemp)
            if(randomCpuC === 1)
            {
                scene.remove(cpuCTemp)
                scene.add(cpuC3)
                cpuCTemp = cpuC3
                idCpuC = abcArray[3]
                document.getElementById("cpuCButton1").disabled = true
                document.getElementById("cpuCButton1").innerHTML = "добавлено"
                document.getElementById("currentConfigCpuC").innerHTML = "NZXT Kraken Z63 RGB"
            }
            else if(randomCpuC === 2)
            {
                scene.remove(cpuCTemp)
                scene.add(cpuC2)
                cpuCTemp = cpuC2
                idCpuC = abcArray[2]
                document.getElementById("cpuCButton2").disabled = true
                document.getElementById("cpuCButton2").innerHTML = "добавлено"
                document.getElementById("currentConfigCpuC").innerHTML = "Fractal Design Lumen S24"
            }
            else if(randomCpuC === 3)
            {
                scene.remove(cpuCTemp)
                scene.add(cpuC1)
                cpuCTemp = cpuC1
                idCpuC = abcArray[1]
                document.getElementById("cpuCButton3").disabled = true
                document.getElementById("cpuCButton3").innerHTML = "добавлено"
                document.getElementById("currentConfigCpuC").innerHTML = "Alseye M120D PLUS (II)"
            }
        }
        urlHandlingDone = false
        cpuCHandlingDone = false
        partsHandlingDone = false
        compatibilityCaseHandlingDone = true
    }

    //URL handler
    if(urlHandlingDone === false)
    {
        url.searchParams.set('id', idCase + idGpu + idMb + idCpuC + idRam + idPb + idCpu + idSsd1 + idSsd2 + idHdd1 + idHdd2 + idChair + idScreen + idKeyboard + idMouse + idMousepad)
        window.history.pushState({}, '', url)
        document.getElementById('vk_share_button').innerHTML = VK.Share.button(url.href, {type: 'custom', text: '<img src="/3d-configurator/img/header/link2.svg" alt="">'})
        urlHandlingDone = true
    }
    // pointLight.distance = guiParams.distance
    // directionalLight1.intensity = guiParams.directionalLightIntencity
    // ambientLight.intensity = guiParams.ambientLightIntencity
    // pointLight1Helper.visible = guiParams.pointLight1HelperVisible
    // camera.fov = guiParams.fov
    // camera.updateProjectionMatrix()
    camera.lookAt(cameraLookAt)
    controls.target = cameraLookAt
	renderer.render( scene, camera )
    requestAnimationFrame( animate )
    TWEEN.update()

    composer.render()
}
animate()

function buttonsForCameraAnimation(posX, posY, posZ, ButtonNumber, cameraPosX, cameraPosY, cameraPosZ)
{
    //disable OrbitControls
    controls.enabled = false
    controls.minPolarAngle = 0
    controls.maxPolarAngle = Math.PI
    controls.minAzimuthAngle = Infinity
    controls.maxAzimuthAngle = Infinity
    controls.maxDistance = Infinity
    controls.minDistance = 0

    document.getElementById("reset3Dconfig").disabled = true

    //Removing Buttons
    var button0 = document.getElementById("button0")
    var button1 = document.getElementById("button1")
    var button2 = document.getElementById("button2")
    var button3 = document.getElementById("button3")
    var button4 = document.getElementById("button4")
    
    if(ButtonNumber === 0)
    {
        button0Pressed = true
        button0.style.display = "none"
        button1.style.display = "none"
        button2.style.display = "none"
        button3.style.display = "none"
        button4.style.display = "none"
    }
    if(ButtonNumber === 1)
    {
        button1Pressed = true
        button0.style.display = "none"
        button1.style.display = "none"
        button3.style.display = "none"
        button4.style.display = "none"
        var chairPosition = new TWEEN.Tween(chairTemp.children[0].position).to({x: -0.632, z: -0.509}, 800).start()
        var chairRotation = new TWEEN.Tween(chairTemp.children[0].rotation).to({y: 0.5}, 800).start()
        document.getElementById("backButton1").disabled = true
    }
    if(ButtonNumber === 2)
    {
        // document.getElementById("teeest").setAttribute("style", "display: none;");
        // document.getElementById("teeest2").setAttribute("style", "display: flex;");

        button2Pressed = true
        button0.style.display = "none"
        button1.style.display = "none"
        button2.style.display = "none"
        button3.style.display = "none"
        button4.style.display = "none"
        // document.getElementById("text1").style.display = "none"

        // screenTemp.visible = false
        // chairTemp.visible = false
        for(let i = 0; i < chairParts.length; i++)
        {
            chairTemp.getObjectByName(chairParts[i]).material.transparent = true
            var chairTransparency = new TWEEN.Tween(chairTemp.getObjectByName(chairParts[i]).material).to({opacity: 0}, 800).start()
        }
        for(let i = 0; i < screenParts.length; i++)
        {
            screenTemp.getObjectByName(screenParts[i]).material.transparent = true
            var screenTransparency = new TWEEN.Tween(screenTemp.getObjectByName(screenParts[i]).material).to({opacity: 0}, 800).start()
        }
        document.getElementById("backButton2").disabled = true
    }
    if(ButtonNumber === 3)
    {
        button1Pressed = true
        button2Pressed = false
        button3Pressed = true
        button0.style.display = "none"
        button1.style.display = "none"
        button2.style.display = "none"
        button3.style.display = "none"
        button4.style.display = "none"
        // document.getElementById("text2").style.display = "none"

        screenTemp.visible = true
        chairTemp.visible = true
        for(let i = 0; i < chairParts.length; i++)
        {
            // chairTemp.getObjectByName(chairParts[i]).material.transparent = true
            var chairTransparency = new TWEEN.Tween(chairTemp.getObjectByName(chairParts[i]).material).to({opacity: 1}, 800).start()
        }
        for(let i = 0; i < screenParts.length; i++)
        {
            // screenTemp.getObjectByName(screenParts[i]).material.transparent = true
            var screenTransparency = new TWEEN.Tween(screenTemp.getObjectByName(screenParts[i]).material).to({opacity: 1}, 800).start()
        }
        document.getElementById("backButton1").disabled = true
        document.getElementById("backButton2").disabled = true
    }
    if(ButtonNumber === 4)
    {
        button0.style.display = "none"
        button1.style.display = "none"
        button2.style.display = "none"
        button3.style.display = "none"
        button4.style.display = "none"
    }
    if(ButtonNumber === 5)
    {
        button0.style.display = "none"
        button1.style.display = "none"
        button2.style.display = "none"
        button3.style.display = "none"
        button4.style.display = "none"
    }
    //applying tween settings
    //!!!!!!!Animation time in both tweens should be the same for the smoothest animation!!!!!!!
    var position = {x: camera.position.x, y: camera.position.y, z: camera.position.z}
    var target = {x: posX,y: posY,z: posZ}
    var tween = new TWEEN.Tween(position).to(target, 800)
    tween.onUpdate(function()
    {
        camera.position.x = position.x
        camera.position.y = position.y
        camera.position.z = position.z
    })
    //Delay before the animation
    //tween.delay(100)
    //Start Animation
    tween.start()

    //onComplete function
    tween.onComplete(function() 
    {
        if(ButtonNumber === 0)
        {
            document.getElementById("text0").style.display = "flex"
            ps5buttonPressed = true
        }
        if(ButtonNumber === 1)
        {
            document.getElementById("text1").style.display = "flex"
            //controls
            controls.enabled = true
            controls.minPolarAngle = Math.PI/3    
            controls.maxPolarAngle = Math.PI/2.2
            controls.minAzimuthAngle = Math.PI/4    
            controls.maxAzimuthAngle = Math.PI/1.5
            controls.maxDistance = 3.1
            controls.minDistance = 1.5
            button2.style.display = "flex"
            document.getElementById("backButton1").disabled = false
        }
        if(ButtonNumber === 2)
        {
            document.getElementById("text2").style.display = "flex"
            controls.enabled = true
            controls.minPolarAngle = 0
            controls.maxPolarAngle = Math.PI/2
            controls.minAzimuthAngle = -Math.PI/9
            controls.maxAzimuthAngle = Math.PI/2
            controls.maxDistance = 1
            controls.minDistance = 0.8
            screenTemp.visible = false
            chairTemp.visible = false
            document.getElementById("backButton2").disabled = false
        }
        if(ButtonNumber === 3)
        {
            button3Pressed = false
            document.getElementById("text1").style.display = "flex"
            //controls
            controls.enabled = true
            controls.minPolarAngle = Math.PI/3    
            controls.maxPolarAngle = Math.PI/2.2
            controls.minAzimuthAngle = Math.PI/4    
            controls.maxAzimuthAngle = Math.PI/1.5
            controls.maxDistance = 3.1
            controls.minDistance = 1.5
            button2.style.display = "flex"

            screenTemp.visible = true
            chairTemp.visible = true

            document.getElementById("backButton1").disabled = false
        }
        if(ButtonNumber === 4)
        {
            document.getElementById("text3").style.display = "flex"
        }
        if(ButtonNumber === 5)
        {
            document.getElementById("text4").style.display = "flex"
        }
        document.getElementById("reset3Dconfig").disabled = false
    })
    var lookAtTween = new TWEEN.Tween(cameraLookAt).to({x: cameraPosX, y: cameraPosY, z: cameraPosZ}, 800).start()
}

function buttonsForBackCameraAnimation(posX, posY, posZ, ButtonNumber)
{
    ps5buttonPressed = false
    //controls
    controls.enabled = false
    controls.minPolarAngle = 0
    controls.maxPolarAngle = Math.PI
    controls.minAzimuthAngle = Infinity
    controls.maxAzimuthAngle = Infinity
    controls.maxDistance = Infinity
    controls.minDistance = 0
    //removing text panels
    // document.getElementById("text0").style.display = "none"
    // document.getElementById("text1").style.display = "none"
    var button2 = document.getElementById("button2")
    button2.style.display = "none"

    document.getElementById("reset3Dconfig").disabled = true
    //applying tween settings
    //TWEEN.removeAll()
    if(ButtonNumber === 1)
    {
        var chairPositionBack = new TWEEN.Tween(chairTemp.children[0].position).to({x: -1.117, z: 0.202}, 800).start()
        var chairRotationBack = new TWEEN.Tween(chairTemp.children[0].rotation).to({y: -1.57}, 800).start()
    }
    if(ButtonNumber === 4)
    {
        document.getElementById("text3").style.display = "none"
    }
    if(ButtonNumber === 5)
    {
        document.getElementById("text4").style.display = "none"
    }
    var position = {x: camera.position.x, y: camera.position.y, z: camera.position.z}
    var target = {x: posX,y: posY,z: posZ}
    var tween = new TWEEN.Tween(position).to(target, 800)
    tween.onUpdate(function()
    {
        camera.position.x = position.x
        camera.position.y = position.y
        camera.position.z = position.z
    });
    tween.start()
    tween.onComplete(function() 
    {
        //console.log('done!')
        var button0 = document.getElementById("button0")
        var button1 = document.getElementById("button1")
        var button3 = document.getElementById("button3")
        var button4 = document.getElementById("button4")
        button0.style.display = "block"
        button1.style.display = "block"
        button3.style.display = "block"
        button4.style.display = "block"
        button0Pressed = false
        button1Pressed = false
        button4Pressed = false
        button5Pressed = false
        //enable OrbitControls
        controls.enabled = true
        controls.minPolarAngle = Math.PI/3
        controls.maxPolarAngle = Math.PI/2
        controls.minAzimuthAngle = Infinity
        controls.maxAzimuthAngle = Infinity
        controls.maxDistance = 1.8
        controls.minDistance = 1.2
        document.getElementById("reset3Dconfig").disabled = false
    })

    var lookAtTween = new TWEEN.Tween(cameraLookAt).to({x: 0, y: 0, z: 0}, 800).start()
}

function onMouseMove(event) {
    if(ps5loaded === true && ps5pressed === true && ps5buttonPressed === true)
    {
        room1.getObjectByName( 'the_room_ps5' ).rotation.y += event.movementX * 0.005;
    }
}
function onTouchMove(e) {
    if(ps5loaded === true && ps5buttonPressed === true)
    {
        currentTouchPos = e.changedTouches[0].pageX
        room1.getObjectByName( 'the_room_ps5' ).rotation.y += (currentTouchPos - startTouchPos) * 0.01
        startTouchPos = currentTouchPos
    }
}
// console.log(sizes.width)

function fullScreen()
{
    var elem = document.documentElement
    if(fullScreen3DconfigOn === false)
    {
        if (elem.requestFullscreen) 
        {
            elem.requestFullscreen()
        } else if (elem.webkitRequestFullscreen) 
        { /* Safari */
            elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) 
        { /* IE11 */
            elem.msRequestFullscreen()
        }
        fullScreen3DconfigOn = true
    }
    else if(fullScreen3DconfigOn === true)
    {
        if (document.exitFullscreen) 
        {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) 
        { /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) 
        { /* IE11 */
            document.msExitFullscreen();
        }
        fullScreen3DconfigOn = false
    }
}

//screenshots
function screenshot()
{
    document.getElementById("screenshot3DPanelId").style.display = "flex "
    document.getElementById("screenshotImgId").remove()
    canvas = document.querySelector('canvas.webgl')
    var image = new Image()
    image.id = "screenshotImgId"
    image.src = canvas.toDataURL()
    document.getElementById('screenshot3DPanelId').appendChild(image)
    controls.enabled = false
}
function saveScreenshot()
{
    canvas = document.querySelector('canvas.webgl')
    let a = document.createElement('a');
    a.href = canvas.toDataURL("image/jpg");
    a.download = 'man-made_3dconfig.png';
    a.click();
}
//screenshots
function closePanel(panel)
{
    // document.getElementById(panel).style.display = "none"
    if(ps5buttonPressed === false)
    controls.enabled = true
}
function configSetDefault()
{
    document.getElementById("reset3Dconfig").disabled = true
    setTimeout(() => 
    {
        document.getElementById("reset3Dconfig").disabled = false
    },1000)
    scene.remove(gpuTemp)
    gpuTemp = gpu1
    scene.add(gpuTemp)
    document.getElementById("currentConfigGpu").innerHTML = "NVIDIA RTX 3060 Ti FE"
    document.getElementById("currentConfigGpu").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigGpu").classList.remove("mm-3d-box-anim")
    },1000)

    scene.remove(mbTemp)
    mbTemp = mb1
    scene.add(mbTemp)
    document.getElementById("currentConfigMb").innerHTML = "ASROCK B660M PRO RS"
    document.getElementById("currentConfigMb").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigMb").classList.remove("mm-3d-box-anim")
    },1000)

    scene.remove(cpuCTemp)
    cpuCTemp = cpuC1
    scene.add(cpuCTemp)
    document.getElementById("currentConfigCpuC").innerHTML = "Alseye M120D PLUS (II)"
    document.getElementById("currentConfigCpuC").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigCpuC").classList.remove("mm-3d-box-anim")
    },1000)

    scene.remove(ramTemp)
    scene.remove(ramTempclone1)
    scene.remove(ramTempclone2)
    scene.remove(ramTempclone3)
    ramTemp = ram1
    ramTempclone1 = ram1clone1
    ramTempclone2 = ram1clone2
    ramTempclone3 = ram1clone3
    scene.add(ramTemp)
    scene.add(ramTempclone1)
    scene.add(ramTempclone2)
    scene.add(ramTempclone3)
    document.getElementById("currentConfigRam").innerHTML = "tforceDelta 8Gb DDR4 3200MHz"
    document.getElementById("currentConfigRam").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigRam").classList.remove("mm-3d-box-anim")
    },1000)

    scene.remove(caseTemp)
    caseTemp = case1
    scene.add(caseTemp)
    document.getElementById("currentConfigCase").innerHTML = "Powercase MISTRAL Micro T3B CMIMTB-L3"
    document.getElementById("currentConfigCase").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigCase").classList.remove("mm-3d-box-anim")
    },1000)

    scene.remove(keyboardTemp)
    keyboardTemp = keyboard1
    scene.add(keyboardTemp)
    document.getElementById("currentConfigKeyboard").innerHTML = "Не выбрано"
    document.getElementById("currentConfigKeyboard").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigKeyboard").classList.remove("mm-3d-box-anim")
    },1000)

    scene.remove(mousepadTemp)
    mousepadTemp = mousepad1
    scene.add(mousepadTemp)
    document.getElementById("currentConfigMousepad").innerHTML = "Не выбрано"
    document.getElementById("currentConfigMousepad").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigMousepad").classList.remove("mm-3d-box-anim")
    },1000)

    scene.remove(screenTemp)
    screenTemp = screen1
    document.getElementById("currentConfigScreen").innerHTML = "Не выбрано"
    document.getElementById("currentConfigScreen").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigScreen").classList.remove("mm-3d-box-anim")
    },1000)
    screenParts = []
    screenTemp.traverse( function( object ) 
    {
        if ( object.isMesh ) 
        {
            screenParts.push(object.name)
        }
    })
    
    scene.add(screenTemp)

    scene.remove(mouseTemp)
    mouseTemp = mouse1
    scene.add(mouseTemp)
    document.getElementById("currentConfigMouse").innerHTML = "Не выбрано"
    document.getElementById("currentConfigMouse").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigMouse").classList.remove("mm-3d-box-anim")
    },1000)

    scene.remove(chairTemp)
    chairTemp = chair1
    if(button1Pressed === false && button2Pressed === false)
    {
        chairTemp.children[0].position.x = -1.131
        chairTemp.children[0].position.y = -1.407
        chairTemp.children[0].position.z = 0.201
        
        chairTemp.children[0].rotation.y = -1.57
    }
    
    chairParts = []
    chairTemp.traverse( function( object ) 
    {
        if ( object.isMesh ) 
        {
            chairParts.push(object.name)
        }
    })
    
    scene.add(chairTemp)
    if(button2Pressed === true)
    {
        chairTemp.visible = false
        screenTemp.visible = false
        for(let i = 0; i < screenParts.length; i++)
        {
            // screenTemp.getObjectByName(screenParts[i]).material.transparent = false
            screenTemp.getObjectByName(screenParts[i]).material.opacity = 0.08
        }
        for(let i = 0; i < chairParts.length; i++)
        {
            // chairTemp.getObjectByName(chairParts[i]).material.transparent = false
            chairTemp.getObjectByName(chairParts[i]).material.opacity = 0.08
        }
    }
    document.getElementById("currentConfigChair").innerHTML = "Не выбрано"
    document.getElementById("currentConfigChair").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigChair").classList.remove("mm-3d-box-anim")
    },1000)

    partsHandlingDone = false

    idCase = "a"
    idGpu = "a"
    idMb = "a"
    idCpuC = "a"
    idRam = "a"
    idPb = "a"
    idCpu = "a"
    idSsd1 = "a"
    idSsd2 = "a"
    idHdd1 = "a"
    idHdd2 = "a"
    idChair = "a"
    idScreen = "a"
    idKeyboard = "a"
    idMouse = "a"
    idMousepad = "a"
    url.searchParams.set('id', 'aaaaaaaaaaaaaaaa')
    window.history.pushState({}, '', url)

    document.getElementById("caseButton1").disabled = false
    document.getElementById("caseButton2").disabled = true
    document.getElementById("caseButton3").disabled = false
    document.getElementById("caseButton4").disabled = false
    document.getElementById("caseButton5").disabled = false
    document.getElementById("caseButton6").disabled = false
    document.getElementById("caseButton1").innerHTML = "Добавить"
    document.getElementById("caseButton2").innerHTML = "добавлено"
    document.getElementById("caseButton3").innerHTML = "Добавить"
    document.getElementById("caseButton4").innerHTML = "Добавить"
    document.getElementById("caseButton5").innerHTML = "Добавить"
    document.getElementById("caseButton6").innerHTML = "Добавить"

    document.getElementById("mbButton1").disabled = false
    document.getElementById("mbButton2").disabled = false
    document.getElementById("mbButton3").disabled = false
    document.getElementById("mbButton4").disabled = false
    document.getElementById("mbButton5").disabled = true
    document.getElementById("mbButton1").innerHTML = "Добавить"
    document.getElementById("mbButton2").innerHTML = "Добавить"
    document.getElementById("mbButton3").innerHTML = "Добавить"
    document.getElementById("mbButton4").innerHTML = "Добавить"
    document.getElementById("mbButton5").innerHTML = "добавлено"

    document.getElementById("gpuButton1").disabled = false
    document.getElementById("gpuButton2").disabled = false
    document.getElementById("gpuButton3").disabled = true
    document.getElementById("gpuButton1").innerHTML = "Добавить"
    document.getElementById("gpuButton2").innerHTML = "Добавить"
    document.getElementById("gpuButton3").innerHTML = "добавлено"

    document.getElementById("cpuCButton1").disabled = false
    document.getElementById("cpuCButton2").disabled = false
    document.getElementById("cpuCButton3").disabled = true
    document.getElementById("cpuCButton1").innerHTML = "Добавить"
    document.getElementById("cpuCButton2").innerHTML = "Добавить"
    document.getElementById("cpuCButton3").innerHTML = "добавлено"

    document.getElementById("ramButton1x2").disabled = false
    document.getElementById("ramButton1x4").disabled = false
    document.getElementById("ramButton2x2").disabled = true
    document.getElementById("ramButton2x4").disabled = false
    document.getElementById("ramButton1x2").innerHTML = "Добавить"
    document.getElementById("ramButton1x4").innerHTML = "Добавить"
    document.getElementById("ramButton2x2").innerHTML = "добавлено"
    document.getElementById("ramButton2x4").innerHTML = "Добавить"

    for(let a = 1; a < 14; a++)
    {
        document.getElementById("pbButton" + a).disabled = false
        document.getElementById("pbButton" + a).innerHTML = "Добавить"
    }
    document.getElementById("pbButton1").disabled = true
    document.getElementById("pbButton1").innerHTML = "добавлено"
    document.getElementById("currentConfigPb").innerHTML = document.getElementById("pbButton1").parentNode.parentNode.innerText.replace("добавлено", "")
    document.getElementById("currentConfigPb").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigPb").classList.remove("mm-3d-box-anim")
    },1000)

    for(let a = 1; a < 11; a++)
    {
        document.getElementById("cpuButton" + a).disabled = false
        document.getElementById("cpuButton" + a).innerHTML = "Добавить"
    }
    document.getElementById("cpuButton1").disabled = true
    document.getElementById("cpuButton1").innerHTML = "добавлено"
    document.getElementById("currentConfigCPU").innerHTML = document.getElementById("cpuButton1").parentNode.parentNode.innerText.replace("добавлено", "")
    document.getElementById("currentConfigCPU").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigCPU").classList.remove("mm-3d-box-anim")
    },1000)

    for(let a = 1; a < 14; a++)
    {
        document.getElementById("ssd1Button" + a).disabled = false
        document.getElementById("ssd1Button" + a).innerHTML = "Добавить"
    }
    document.getElementById("ssd1Button1").disabled = true
    document.getElementById("ssd1Button1").innerHTML = "добавлено"
    document.getElementById("currentConfigSSD1").innerHTML = document.getElementById("ssd1Button1").parentNode.parentNode.innerText.replace("добавлено", "")
    document.getElementById("currentConfigSSD1").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigSSD1").classList.remove("mm-3d-box-anim")
    },1000)

    for(let a = 1; a < 14; a++)
    {
        document.getElementById("ssd2Button" + a).disabled = false
        document.getElementById("ssd2Button" + a).innerHTML = "Добавить"
    }
    document.getElementById("ssd2Button1").disabled = true
    document.getElementById("ssd2Button1").innerHTML = "добавлено"
    document.getElementById("currentConfigSSD2").innerHTML = document.getElementById("ssd2Button1").parentNode.parentNode.innerText.replace("добавлено", "")
    document.getElementById("currentConfigSSD2").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigSSD2").classList.remove("mm-3d-box-anim")
    },1000)

    for(let a = 1; a < 16; a++)
    {
        document.getElementById("hdd1Button" + a).disabled = false
        document.getElementById("hdd1Button" + a).innerHTML = "Добавить"
    }
    document.getElementById("hdd1Button1").disabled = true
    document.getElementById("hdd1Button1").innerHTML = "добавлено"
    document.getElementById("currentConfigHDD1").innerHTML = document.getElementById("hdd1Button1").parentNode.parentNode.innerText.replace("добавлено", "")
    document.getElementById("currentConfigHDD1").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigHDD1").classList.remove("mm-3d-box-anim")
    },1000)

    for(let a = 1; a < 16; a++)
    {
        document.getElementById("hdd2Button" + a).disabled = false
        document.getElementById("hdd2Button" + a).innerHTML = "Добавить"
    }
    document.getElementById("hdd2Button1").disabled = true
    document.getElementById("hdd2Button1").innerHTML = "добавлено"
    document.getElementById("currentConfigHDD2").innerHTML = document.getElementById("hdd2Button1").parentNode.parentNode.innerText.replace("добавлено", "")
    document.getElementById("currentConfigHDD2").classList.add("mm-3d-box-anim")
    setTimeout(() => {
        document.getElementById("currentConfigHDD2").classList.remove("mm-3d-box-anim")
    },1000)


    document.getElementById("screenButton1").disabled = true
    document.getElementById("screenButton2").disabled = false
    document.getElementById("screenButton3").disabled = false
    document.getElementById("screenButton4").disabled = false
    document.getElementById("screenButton5").disabled = false
    document.getElementById("screenButton1").innerHTML = "добавлено"
    document.getElementById("screenButton2").innerHTML = "Добавить"
    document.getElementById("screenButton3").innerHTML = "Добавить"
    document.getElementById("screenButton4").innerHTML = "Добавить"
    document.getElementById("screenButton5").innerHTML = "Добавить"

    document.getElementById("keyboardButton1").disabled = true
    document.getElementById("keyboardButton2").disabled = false
    document.getElementById("keyboardButton3").disabled = false
    document.getElementById("keyboardButton4").disabled = false
    document.getElementById("keyboardButton5").disabled = false
    document.getElementById("keyboardButton1").innerHTML = "добавлено"
    document.getElementById("keyboardButton2").innerHTML = "Добавить"
    document.getElementById("keyboardButton3").innerHTML = "Добавить"
    document.getElementById("keyboardButton4").innerHTML = "Добавить"
    document.getElementById("keyboardButton5").innerHTML = "Добавить"

    document.getElementById("mouseButton1").disabled = true
    document.getElementById("mouseButton2").disabled = false
    document.getElementById("mouseButton3").disabled = false
    document.getElementById("mouseButton4").disabled = false
    document.getElementById("mouseButton5").disabled = false
    document.getElementById("mouseButton1").innerHTML = "добавлено"
    document.getElementById("mouseButton2").innerHTML = "Добавить"
    document.getElementById("mouseButton3").innerHTML = "Добавить"
    document.getElementById("mouseButton4").innerHTML = "Добавить"
    document.getElementById("mouseButton5").innerHTML = "Добавить"

    document.getElementById("mousepadButton1").disabled = true
    document.getElementById("mousepadButton2").disabled = false
    document.getElementById("mousepadButton3").disabled = false
    document.getElementById("mousepadButton4").disabled = false
    document.getElementById("mousepadButton5").disabled = false
    document.getElementById("mousepadButton1").innerHTML = "добавлено"
    document.getElementById("mousepadButton2").innerHTML = "Добавить"
    document.getElementById("mousepadButton3").innerHTML = "Добавить"
    document.getElementById("mousepadButton4").innerHTML = "Добавить"
    document.getElementById("mousepadButton5").innerHTML = "Добавить"

    document.getElementById("chairButton1").disabled = true
    document.getElementById("chairButton2").disabled = false
    document.getElementById("chairButton3").disabled = false
    document.getElementById("chairButton4").disabled = false
    document.getElementById("chairButton1").innerHTML = "добавлено"
    document.getElementById("chairButton2").innerHTML = "Добавить"
    document.getElementById("chairButton3").innerHTML = "Добавить"
    document.getElementById("chairButton4").innerHTML = "Добавить"



    caseType = 0
    //compatibilityCaseHandlingDone = false
    //compatibilityMbHandlingDone = false
    cpuCHandlingDone = false
}

function configButtonsHandler(addModel, removeModel, modelType, compatibilityType, partId, partName, buttonNumberTemp)
{
    if(compatibilityType === 0)
    {
        caseType = 0
        //compatibilityCaseHandlingDone = false
        //compatibilityMbHandlingDone = false
    }
    else if(compatibilityType === 1)
    {
        caseType = 1
        //compatibilityCaseHandlingDone = false
        //compatibilityMbHandlingDone = false
    }
    else if(compatibilityType === 2)
    {
        caseType = 2
        //compatibilityCaseHandlingDone = false
        //compatibilityMbHandlingDone = false
    }
    else if(compatibilityType === 3)
    {
        mbType = 0
        //compatibilityCaseHandlingDone = false
        //compatibilityMbHandlingDone = false
    }
    else if(compatibilityType === 4)
    {
        mbType = 1
        //compatibilityCaseHandlingDone = false
        //compatibilityMbHandlingDone = false
    }

    scene.remove(removeModel)
    scene.add(addModel)
    if(modelType === "case")
    {
        caseTemp = addModel
        idCase = partId
        urlHandlingDone = false
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("caseButton1").disabled = true
            document.getElementById("caseButton2").disabled = false
            document.getElementById("caseButton3").disabled = false
            document.getElementById("caseButton4").disabled = false
            document.getElementById("caseButton5").disabled = false
            document.getElementById("caseButton6").disabled = false

            document.getElementById("caseButton1").innerHTML = "добавлено"
            document.getElementById("caseButton2").innerHTML = "Добавить"
            document.getElementById("caseButton3").innerHTML = "Добавить"
            document.getElementById("caseButton4").innerHTML = "Добавить"
            document.getElementById("caseButton5").innerHTML = "Добавить"
            document.getElementById("caseButton6").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("caseButton1").disabled = false
            document.getElementById("caseButton2").disabled = true
            document.getElementById("caseButton3").disabled = false
            document.getElementById("caseButton4").disabled = false
            document.getElementById("caseButton5").disabled = false
            document.getElementById("caseButton6").disabled = false

            document.getElementById("caseButton1").innerHTML = "Добавить"
            document.getElementById("caseButton2").innerHTML = "добавлено"
            document.getElementById("caseButton3").innerHTML = "Добавить"
            document.getElementById("caseButton4").innerHTML = "Добавить"
            document.getElementById("caseButton5").innerHTML = "Добавить"
            document.getElementById("caseButton6").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("caseButton1").disabled = false
            document.getElementById("caseButton2").disabled = false
            document.getElementById("caseButton3").disabled = true
            document.getElementById("caseButton4").disabled = false
            document.getElementById("caseButton5").disabled = false
            document.getElementById("caseButton6").disabled = false

            document.getElementById("caseButton1").innerHTML = "Добавить"
            document.getElementById("caseButton2").innerHTML = "Добавить"
            document.getElementById("caseButton3").innerHTML = "добавлено"
            document.getElementById("caseButton4").innerHTML = "Добавить"
            document.getElementById("caseButton5").innerHTML = "Добавить"
            document.getElementById("caseButton6").innerHTML = "Добавить"
                break
            case 4:
            document.getElementById("caseButton1").disabled = false
            document.getElementById("caseButton2").disabled = false
            document.getElementById("caseButton3").disabled = false
            document.getElementById("caseButton4").disabled = true
            document.getElementById("caseButton5").disabled = false
            document.getElementById("caseButton6").disabled = false

            document.getElementById("caseButton1").innerHTML = "Добавить"
            document.getElementById("caseButton2").innerHTML = "Добавить"
            document.getElementById("caseButton3").innerHTML = "Добавить"
            document.getElementById("caseButton4").innerHTML = "добавлено"
            document.getElementById("caseButton5").innerHTML = "Добавить"
            document.getElementById("caseButton6").innerHTML = "Добавить"
                break
            case 5:
            document.getElementById("caseButton1").disabled = false
            document.getElementById("caseButton2").disabled = false
            document.getElementById("caseButton3").disabled = false
            document.getElementById("caseButton4").disabled = false
            document.getElementById("caseButton5").disabled = true
            document.getElementById("caseButton6").disabled = false

            document.getElementById("caseButton1").innerHTML = "Добавить"
            document.getElementById("caseButton2").innerHTML = "Добавить"
            document.getElementById("caseButton3").innerHTML = "Добавить"
            document.getElementById("caseButton4").innerHTML = "Добавить"
            document.getElementById("caseButton5").innerHTML = "добавлено"
            document.getElementById("caseButton6").innerHTML = "Добавить"
                break
            case 6:
            document.getElementById("caseButton1").disabled = false
            document.getElementById("caseButton2").disabled = false
            document.getElementById("caseButton3").disabled = false
            document.getElementById("caseButton4").disabled = false
            document.getElementById("caseButton5").disabled = false
            document.getElementById("caseButton6").disabled = true

            document.getElementById("caseButton1").innerHTML = "Добавить"
            document.getElementById("caseButton2").innerHTML = "Добавить"
            document.getElementById("caseButton3").innerHTML = "Добавить"
            document.getElementById("caseButton4").innerHTML = "Добавить"
            document.getElementById("caseButton5").innerHTML = "Добавить"
            document.getElementById("caseButton6").innerHTML = "добавлено"
                break
        }
        document.getElementById("currentConfigCase").innerHTML = partName
        document.getElementById("currentConfigCase").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigCase").classList.remove("mm-3d-box-anim")
        },1000)
    }
    if(modelType === "mb")
    {
        mbTemp = addModel
        idMb = partId
        urlHandlingDone = false
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("mbButton1").disabled = true
            document.getElementById("mbButton2").disabled = false
            document.getElementById("mbButton3").disabled = false
            document.getElementById("mbButton4").disabled = false
            document.getElementById("mbButton5").disabled = false

            document.getElementById("mbButton1").innerHTML = "добавлено"
            document.getElementById("mbButton2").innerHTML = "Добавить"
            document.getElementById("mbButton3").innerHTML = "Добавить"
            document.getElementById("mbButton4").innerHTML = "Добавить"
            document.getElementById("mbButton5").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("mbButton1").disabled = false
            document.getElementById("mbButton2").disabled = true
            document.getElementById("mbButton3").disabled = false
            document.getElementById("mbButton4").disabled = false
            document.getElementById("mbButton5").disabled = false

            document.getElementById("mbButton1").innerHTML = "Добавить"
            document.getElementById("mbButton2").innerHTML = "добавлено"
            document.getElementById("mbButton3").innerHTML = "Добавить"
            document.getElementById("mbButton4").innerHTML = "Добавить"
            document.getElementById("mbButton5").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("mbButton1").disabled = false
            document.getElementById("mbButton2").disabled = false
            document.getElementById("mbButton3").disabled = true
            document.getElementById("mbButton4").disabled = false
            document.getElementById("mbButton5").disabled = false

            document.getElementById("mbButton1").innerHTML = "Добавить"
            document.getElementById("mbButton2").innerHTML = "Добавить"
            document.getElementById("mbButton3").innerHTML = "добавлено"
            document.getElementById("mbButton4").innerHTML = "Добавить"
            document.getElementById("mbButton5").innerHTML = "Добавить"
                break
            case 4:
            document.getElementById("mbButton1").disabled = false
            document.getElementById("mbButton2").disabled = false
            document.getElementById("mbButton3").disabled = false
            document.getElementById("mbButton4").disabled = true
            document.getElementById("mbButton5").disabled = false

            document.getElementById("mbButton1").innerHTML = "Добавить"
            document.getElementById("mbButton2").innerHTML = "Добавить"
            document.getElementById("mbButton3").innerHTML = "Добавить"
            document.getElementById("mbButton4").innerHTML = "добавлено"
            document.getElementById("mbButton5").innerHTML = "Добавить"
                break
            case 5:
            document.getElementById("mbButton1").disabled = false
            document.getElementById("mbButton2").disabled = false
            document.getElementById("mbButton3").disabled = false
            document.getElementById("mbButton4").disabled = false
            document.getElementById("mbButton5").disabled = true

            document.getElementById("mbButton1").innerHTML = "Добавить"
            document.getElementById("mbButton2").innerHTML = "Добавить"
            document.getElementById("mbButton3").innerHTML = "Добавить"
            document.getElementById("mbButton4").innerHTML = "Добавить"
            document.getElementById("mbButton5").innerHTML = "добавлено"
                break
        }
        document.getElementById("currentConfigMb").innerHTML = partName
        document.getElementById("currentConfigMb").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigMb").classList.remove("mm-3d-box-anim")
        },1000)
    }
    if(modelType === "gpu")
    {
        gpuTemp = addModel
        idGpu = partId
        urlHandlingDone = false
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("gpuButton1").disabled = true
            document.getElementById("gpuButton2").disabled = false
            document.getElementById("gpuButton3").disabled = false

            document.getElementById("gpuButton1").innerHTML = "добавлено"
            document.getElementById("gpuButton2").innerHTML = "Добавить"
            document.getElementById("gpuButton3").innerHTML = "Добавить"
            gpuType = 1
                break
            case 2:
            document.getElementById("gpuButton1").disabled = false
            document.getElementById("gpuButton2").disabled = true
            document.getElementById("gpuButton3").disabled = false

            document.getElementById("gpuButton1").innerHTML = "Добавить"
            document.getElementById("gpuButton2").innerHTML = "добавлено"
            document.getElementById("gpuButton3").innerHTML = "Добавить"
            gpuType = 1
                break
            case 3:
            document.getElementById("gpuButton1").disabled = false
            document.getElementById("gpuButton2").disabled = false
            document.getElementById("gpuButton3").disabled = true

            document.getElementById("gpuButton1").innerHTML = "Добавить"
            document.getElementById("gpuButton2").innerHTML = "Добавить"
            document.getElementById("gpuButton3").innerHTML = "добавлено"
            gpuType = 0
                break
        }
        document.getElementById("currentConfigGpu").innerHTML = partName
        document.getElementById("currentConfigGpu").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigGpu").classList.remove("mm-3d-box-anim")
        },1000)
    }
    if(modelType === "cpuC")
    {
        cpuCTemp = addModel
        idCpuC = partId
        urlHandlingDone = false
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("cpuCButton1").disabled = true
            document.getElementById("cpuCButton2").disabled = false
            document.getElementById("cpuCButton3").disabled = false

            document.getElementById("cpuCButton1").innerHTML = "добавлено"
            document.getElementById("cpuCButton2").innerHTML = "Добавить"
            document.getElementById("cpuCButton3").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("cpuCButton1").disabled = false
            document.getElementById("cpuCButton2").disabled = true
            document.getElementById("cpuCButton3").disabled = false

            document.getElementById("cpuCButton1").innerHTML = "Добавить"
            document.getElementById("cpuCButton2").innerHTML = "добавлено"
            document.getElementById("cpuCButton3").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("cpuCButton1").disabled = false
            document.getElementById("cpuCButton2").disabled = false
            document.getElementById("cpuCButton3").disabled = true

            document.getElementById("cpuCButton1").innerHTML = "Добавить"
            document.getElementById("cpuCButton2").innerHTML = "Добавить"
            document.getElementById("cpuCButton3").innerHTML = "добавлено"
                break
        }
        document.getElementById("currentConfigCpuC").innerHTML = partName
        document.getElementById("currentConfigCpuC").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigCpuC").classList.remove("mm-3d-box-anim")
        },1000)
    }
    partsHandlingDone = false
    cpuCHandlingDone = false
}
function ramButtonsHandler(rum1Add, rum2Add, rum3Add, rum4Add, ram1Remove, ram2Remove, ram3Remove, ram4Remove, ramAmount, ramId, ramName, buttonNumberTemp)
{
    scene.remove(ram1Remove)
    scene.remove(ram2Remove)
    scene.remove(ram3Remove)
    scene.remove(ram4Remove)
    scene.add(rum1Add)
    scene.add(rum2Add)
    scene.add(rum3Add)
    scene.add(rum4Add)
    ramTemp = rum1Add
    ramTempclone1 = rum2Add
    ramTempclone2 = rum3Add
    ramTempclone3 = rum4Add
    if(ramAmount === 2)
    {
        rum2Add.visible = false
        rum4Add.visible = false
    }
    if(ramAmount === 4)
    {
        rum2Add.visible = true
        rum4Add.visible = true
    }
    idRam = ramId
    urlHandlingDone = false
    partsHandlingDone = false
    switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("ramButton1x2").disabled = true
            document.getElementById("ramButton1x4").disabled = false
            document.getElementById("ramButton2x2").disabled = false
            document.getElementById("ramButton2x4").disabled = false

            document.getElementById("ramButton1x2").innerHTML = "добавлено"
            document.getElementById("ramButton1x4").innerHTML = "Добавить"
            document.getElementById("ramButton2x2").innerHTML = "Добавить"
            document.getElementById("ramButton2x4").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("ramButton1x2").disabled = false
            document.getElementById("ramButton1x4").disabled = true
            document.getElementById("ramButton2x2").disabled = false
            document.getElementById("ramButton2x4").disabled = false

            document.getElementById("ramButton1x2").innerHTML = "Добавить"
            document.getElementById("ramButton1x4").innerHTML = "добавлено"
            document.getElementById("ramButton2x2").innerHTML = "Добавить"
            document.getElementById("ramButton2x4").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("ramButton1x2").disabled = false
            document.getElementById("ramButton1x4").disabled = false
            document.getElementById("ramButton2x2").disabled = true
            document.getElementById("ramButton2x4").disabled = false

            document.getElementById("ramButton1x2").innerHTML = "Добавить"
            document.getElementById("ramButton1x4").innerHTML = "Добавить"
            document.getElementById("ramButton2x2").innerHTML = "добавлено"
            document.getElementById("ramButton2x4").innerHTML = "Добавить"
                break
            case 4:
            document.getElementById("ramButton1x2").disabled = false
            document.getElementById("ramButton1x4").disabled = false
            document.getElementById("ramButton2x2").disabled = false
            document.getElementById("ramButton2x4").disabled = true

            document.getElementById("ramButton1x2").innerHTML = "Добавить"
            document.getElementById("ramButton1x4").innerHTML = "Добавить"
            document.getElementById("ramButton2x2").innerHTML = "Добавить"
            document.getElementById("ramButton2x4").innerHTML = "добавлено"
                break
        }
    document.getElementById("currentConfigRam").innerHTML = ramName
        document.getElementById("currentConfigRam").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigRam").classList.remove("mm-3d-box-anim")
        },1000)
}

function accessoriesButtonsHandler(addModel, removeModel, modelType, partId, partName, buttonNumberTemp)
{
    scene.remove(removeModel)
    scene.add(addModel)
    if(modelType === "screen")
    {
        screenParts = []
        screenTemp = addModel
        screenTemp.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                screenParts.push(object.name)
            }
        })
        for(let i = 0; i < screenParts.length; i++)
        {
            screenTemp.getObjectByName(screenParts[i]).material.transparent = true
            screenTemp.getObjectByName(screenParts[i]).material.opacity = 1
        }
        idScreen = partId
        urlHandlingDone = false
        screenTemp.visible = true
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("screenButton1").disabled = true
            document.getElementById("screenButton2").disabled = false
            document.getElementById("screenButton3").disabled = false
            document.getElementById("screenButton4").disabled = false
            document.getElementById("screenButton5").disabled = false

            document.getElementById("screenButton1").innerHTML = "добавлено"
            document.getElementById("screenButton2").innerHTML = "Добавить"
            document.getElementById("screenButton3").innerHTML = "Добавить"
            document.getElementById("screenButton4").innerHTML = "Добавить"
            document.getElementById("screenButton5").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("screenButton1").disabled = false
            document.getElementById("screenButton2").disabled = true
            document.getElementById("screenButton3").disabled = false
            document.getElementById("screenButton4").disabled = false
            document.getElementById("screenButton5").disabled = false

            document.getElementById("screenButton1").innerHTML = "Добавить"
            document.getElementById("screenButton2").innerHTML = "добавлено"
            document.getElementById("screenButton3").innerHTML = "Добавить"
            document.getElementById("screenButton4").innerHTML = "Добавить"
            document.getElementById("screenButton5").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("screenButton1").disabled = false
            document.getElementById("screenButton2").disabled = false
            document.getElementById("screenButton3").disabled = true
            document.getElementById("screenButton4").disabled = false
            document.getElementById("screenButton5").disabled = false

            document.getElementById("screenButton1").innerHTML = "Добавить"
            document.getElementById("screenButton2").innerHTML = "Добавить"
            document.getElementById("screenButton3").innerHTML = "добавлено"
            document.getElementById("screenButton4").innerHTML = "Добавить"
            document.getElementById("screenButton5").innerHTML = "Добавить"
                break
            case 4:
            document.getElementById("screenButton1").disabled = false
            document.getElementById("screenButton2").disabled = false
            document.getElementById("screenButton3").disabled = false
            document.getElementById("screenButton4").disabled = true
            document.getElementById("screenButton5").disabled = false

            document.getElementById("screenButton1").innerHTML = "Добавить"
            document.getElementById("screenButton2").innerHTML = "Добавить"
            document.getElementById("screenButton3").innerHTML = "Добавить"
            document.getElementById("screenButton4").innerHTML = "добавлено"
            document.getElementById("screenButton5").innerHTML = "Добавить"
                break
            case 5:
            document.getElementById("screenButton1").disabled = false
            document.getElementById("screenButton2").disabled = false
            document.getElementById("screenButton3").disabled = false
            document.getElementById("screenButton4").disabled = false
            document.getElementById("screenButton5").disabled = true

            document.getElementById("screenButton1").innerHTML = "Добавить"
            document.getElementById("screenButton2").innerHTML = "Добавить"
            document.getElementById("screenButton3").innerHTML = "Добавить"
            document.getElementById("screenButton4").innerHTML = "Добавить"
            document.getElementById("screenButton5").innerHTML = "добавлено"
                break
        }
        document.getElementById("currentConfigScreen").innerHTML = partName
        document.getElementById("currentConfigScreen").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigScreen").classList.remove("mm-3d-box-anim")
        },1000)
    }
    if(modelType === "keyboard")
    {
        keyboardTemp = addModel
        idKeyboard = partId
        urlHandlingDone = false
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("keyboardButton1").disabled = true
            document.getElementById("keyboardButton2").disabled = false
            document.getElementById("keyboardButton3").disabled = false
            document.getElementById("keyboardButton4").disabled = false
            document.getElementById("keyboardButton5").disabled = false

            document.getElementById("keyboardButton1").innerHTML = "добавлено"
            document.getElementById("keyboardButton2").innerHTML = "Добавить"
            document.getElementById("keyboardButton3").innerHTML = "Добавить"
            document.getElementById("keyboardButton4").innerHTML = "Добавить"
            document.getElementById("keyboardButton5").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("keyboardButton1").disabled = false
            document.getElementById("keyboardButton2").disabled = true
            document.getElementById("keyboardButton3").disabled = false
            document.getElementById("keyboardButton4").disabled = false
            document.getElementById("keyboardButton5").disabled = false

            document.getElementById("keyboardButton1").innerHTML = "Добавить"
            document.getElementById("keyboardButton2").innerHTML = "добавлено"
            document.getElementById("keyboardButton3").innerHTML = "Добавить"
            document.getElementById("keyboardButton4").innerHTML = "Добавить"
            document.getElementById("keyboardButton5").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("keyboardButton1").disabled = false
            document.getElementById("keyboardButton2").disabled = false
            document.getElementById("keyboardButton3").disabled = true
            document.getElementById("keyboardButton4").disabled = false
            document.getElementById("keyboardButton5").disabled = false

            document.getElementById("keyboardButton1").innerHTML = "Добавить"
            document.getElementById("keyboardButton2").innerHTML = "Добавить"
            document.getElementById("keyboardButton3").innerHTML = "добавлено"
            document.getElementById("keyboardButton4").innerHTML = "Добавить"
            document.getElementById("keyboardButton5").innerHTML = "Добавить"
                break
            case 4:
            document.getElementById("keyboardButton1").disabled = false
            document.getElementById("keyboardButton2").disabled = false
            document.getElementById("keyboardButton3").disabled = false
            document.getElementById("keyboardButton4").disabled = true
            document.getElementById("keyboardButton5").disabled = false

            document.getElementById("keyboardButton1").innerHTML = "Добавить"
            document.getElementById("keyboardButton2").innerHTML = "Добавить"
            document.getElementById("keyboardButton3").innerHTML = "Добавить"
            document.getElementById("keyboardButton4").innerHTML = "добавлено"
            document.getElementById("keyboardButton5").innerHTML = "Добавить"
                break
            case 5:
            document.getElementById("keyboardButton1").disabled = false
            document.getElementById("keyboardButton2").disabled = false
            document.getElementById("keyboardButton3").disabled = false
            document.getElementById("keyboardButton4").disabled = false
            document.getElementById("keyboardButton5").disabled = true

            document.getElementById("keyboardButton1").innerHTML = "Добавить"
            document.getElementById("keyboardButton2").innerHTML = "Добавить"
            document.getElementById("keyboardButton3").innerHTML = "Добавить"
            document.getElementById("keyboardButton4").innerHTML = "Добавить"
            document.getElementById("keyboardButton5").innerHTML = "добавлено"
                break
        }
        document.getElementById("currentConfigKeyboard").innerHTML = partName
        document.getElementById("currentConfigKeyboard").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigKeyboard").classList.remove("mm-3d-box-anim")
        },1000)
    }
    if(modelType === "mouse")
    {
        mouseTemp = addModel
        idMouse = partId
        urlHandlingDone = false
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("mouseButton1").disabled = true
            document.getElementById("mouseButton2").disabled = false
            document.getElementById("mouseButton3").disabled = false
            document.getElementById("mouseButton4").disabled = false
            document.getElementById("mouseButton5").disabled = false

            document.getElementById("mouseButton1").innerHTML = "добавлено"
            document.getElementById("mouseButton2").innerHTML = "Добавить"
            document.getElementById("mouseButton3").innerHTML = "Добавить"
            document.getElementById("mouseButton4").innerHTML = "Добавить"
            document.getElementById("mouseButton5").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("mouseButton1").disabled = false
            document.getElementById("mouseButton2").disabled = true
            document.getElementById("mouseButton3").disabled = false
            document.getElementById("mouseButton4").disabled = false
            document.getElementById("mouseButton5").disabled = false

            document.getElementById("mouseButton1").innerHTML = "Добавить"
            document.getElementById("mouseButton2").innerHTML = "добавлено"
            document.getElementById("mouseButton3").innerHTML = "Добавить"
            document.getElementById("mouseButton4").innerHTML = "Добавить"
            document.getElementById("mouseButton5").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("mouseButton1").disabled = false
            document.getElementById("mouseButton2").disabled = false
            document.getElementById("mouseButton3").disabled = true
            document.getElementById("mouseButton4").disabled = false
            document.getElementById("mouseButton5").disabled = false

            document.getElementById("mouseButton1").innerHTML = "Добавить"
            document.getElementById("mouseButton2").innerHTML = "Добавить"
            document.getElementById("mouseButton3").innerHTML = "добавлено"
            document.getElementById("mouseButton4").innerHTML = "Добавить"
            document.getElementById("mouseButton5").innerHTML = "Добавить"
                break
            case 4:
            document.getElementById("mouseButton1").disabled = false
            document.getElementById("mouseButton2").disabled = false
            document.getElementById("mouseButton3").disabled = false
            document.getElementById("mouseButton4").disabled = true
            document.getElementById("mouseButton5").disabled = false

            document.getElementById("mouseButton1").innerHTML = "Добавить"
            document.getElementById("mouseButton2").innerHTML = "Добавить"
            document.getElementById("mouseButton3").innerHTML = "Добавить"
            document.getElementById("mouseButton4").innerHTML = "добавлено"
            document.getElementById("mouseButton5").innerHTML = "Добавить"
                break
            case 5:
            document.getElementById("mouseButton1").disabled = false
            document.getElementById("mouseButton2").disabled = false
            document.getElementById("mouseButton3").disabled = false
            document.getElementById("mouseButton4").disabled = false
            document.getElementById("mouseButton5").disabled = true

            document.getElementById("mouseButton1").innerHTML = "Добавить"
            document.getElementById("mouseButton2").innerHTML = "Добавить"
            document.getElementById("mouseButton3").innerHTML = "Добавить"
            document.getElementById("mouseButton4").innerHTML = "Добавить"
            document.getElementById("mouseButton5").innerHTML = "добавлено"
                break
        }
        document.getElementById("currentConfigMouse").innerHTML = partName
        document.getElementById("currentConfigMouse").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigMouse").classList.remove("mm-3d-box-anim")
        },1000)
    }
    if(modelType === "mousepad")
    {
        mousepadTemp = addModel
        idMousepad = partId
        urlHandlingDone = false
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("mousepadButton1").disabled = true
            document.getElementById("mousepadButton2").disabled = false
            document.getElementById("mousepadButton3").disabled = false
            document.getElementById("mousepadButton4").disabled = false
            document.getElementById("mousepadButton5").disabled = false

            document.getElementById("mousepadButton1").innerHTML = "добавлено"
            document.getElementById("mousepadButton2").innerHTML = "Добавить"
            document.getElementById("mousepadButton3").innerHTML = "Добавить"
            document.getElementById("mousepadButton4").innerHTML = "Добавить"
            document.getElementById("mousepadButton5").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("mousepadButton1").disabled = false
            document.getElementById("mousepadButton2").disabled = true
            document.getElementById("mousepadButton3").disabled = false
            document.getElementById("mousepadButton4").disabled = false
            document.getElementById("mousepadButton5").disabled = false

            document.getElementById("mousepadButton1").innerHTML = "Добавить"
            document.getElementById("mousepadButton2").innerHTML = "добавлено"
            document.getElementById("mousepadButton3").innerHTML = "Добавить"
            document.getElementById("mousepadButton4").innerHTML = "Добавить"
            document.getElementById("mousepadButton5").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("mousepadButton1").disabled = false
            document.getElementById("mousepadButton2").disabled = false
            document.getElementById("mousepadButton3").disabled = true
            document.getElementById("mousepadButton4").disabled = false
            document.getElementById("mousepadButton5").disabled = false

            document.getElementById("mousepadButton1").innerHTML = "Добавить"
            document.getElementById("mousepadButton2").innerHTML = "Добавить"
            document.getElementById("mousepadButton3").innerHTML = "добавлено"
            document.getElementById("mousepadButton4").innerHTML = "Добавить"
            document.getElementById("mousepadButton5").innerHTML = "Добавить"
                break
            case 4:
            document.getElementById("mousepadButton1").disabled = false
            document.getElementById("mousepadButton2").disabled = false
            document.getElementById("mousepadButton3").disabled = false
            document.getElementById("mousepadButton4").disabled = true
            document.getElementById("mousepadButton5").disabled = false

            document.getElementById("mousepadButton1").innerHTML = "Добавить"
            document.getElementById("mousepadButton2").innerHTML = "Добавить"
            document.getElementById("mousepadButton3").innerHTML = "Добавить"
            document.getElementById("mousepadButton4").innerHTML = "добавлено"
            document.getElementById("mousepadButton5").innerHTML = "Добавить"
                break
            case 5:
            document.getElementById("mousepadButton1").disabled = false
            document.getElementById("mousepadButton2").disabled = false
            document.getElementById("mousepadButton3").disabled = false
            document.getElementById("mousepadButton4").disabled = false
            document.getElementById("mousepadButton5").disabled = true

            document.getElementById("mousepadButton1").innerHTML = "Добавить"
            document.getElementById("mousepadButton2").innerHTML = "Добавить"
            document.getElementById("mousepadButton3").innerHTML = "Добавить"
            document.getElementById("mousepadButton4").innerHTML = "Добавить"
            document.getElementById("mousepadButton5").innerHTML = "добавлено"
                break
        }
        document.getElementById("currentConfigMousepad").innerHTML = partName
        document.getElementById("currentConfigMousepad").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigMousepad").classList.remove("mm-3d-box-anim")
        },1000)
    }
    if(modelType === "chair")
    {
        chairParts = []
        chairTemp = addModel
        chairTemp.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                chairParts.push(object.name)
            }
        })
        for(let i = 0; i < chairParts.length; i++)
        {
            chairTemp.getObjectByName(chairParts[i]).material.transparent = true
            chairTemp.getObjectByName(chairParts[i]).material.opacity = 1
        }
        idChair = partId
        urlHandlingDone = false
        if(chairTemp != chair1)
        {
            chairTemp.children[0].position.x = -0.632
            chairTemp.children[0].position.z = -0.509
            chairTemp.children[0].rotation.set(0, 0.5, 0)
            chairTemp.visible = true
        }
        switch(buttonNumberTemp)
        {
            case 1:
            document.getElementById("chairButton1").disabled = true
            document.getElementById("chairButton2").disabled = false
            document.getElementById("chairButton3").disabled = false
            document.getElementById("chairButton4").disabled = false

            document.getElementById("chairButton1").innerHTML = "добавлено"
            document.getElementById("chairButton2").innerHTML = "Добавить"
            document.getElementById("chairButton3").innerHTML = "Добавить"
            document.getElementById("chairButton4").innerHTML = "Добавить"
                break
            case 2:
            document.getElementById("chairButton1").disabled = false
            document.getElementById("chairButton2").disabled = true
            document.getElementById("chairButton3").disabled = false
            document.getElementById("chairButton4").disabled = false

            document.getElementById("chairButton1").innerHTML = "Добавить"
            document.getElementById("chairButton2").innerHTML = "добавлено"
            document.getElementById("chairButton3").innerHTML = "Добавить"
            document.getElementById("chairButton4").innerHTML = "Добавить"
                break
            case 3:
            document.getElementById("chairButton1").disabled = false
            document.getElementById("chairButton2").disabled = false
            document.getElementById("chairButton3").disabled = true
            document.getElementById("chairButton4").disabled = false

            document.getElementById("chairButton1").innerHTML = "Добавить"
            document.getElementById("chairButton2").innerHTML = "Добавить"
            document.getElementById("chairButton3").innerHTML = "добавлено"
            document.getElementById("chairButton4").innerHTML = "Добавить"
                break
            case 4:
            document.getElementById("chairButton1").disabled = false
            document.getElementById("chairButton2").disabled = false
            document.getElementById("chairButton3").disabled = false
            document.getElementById("chairButton4").disabled = true

            document.getElementById("chairButton1").innerHTML = "Добавить"
            document.getElementById("chairButton2").innerHTML = "Добавить"
            document.getElementById("chairButton3").innerHTML = "Добавить"
            document.getElementById("chairButton4").innerHTML = "добавлено"
                break
        }
        document.getElementById("currentConfigChair").innerHTML = partName
        document.getElementById("currentConfigChair").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigChair").classList.remove("mm-3d-box-anim")
        },1000)
    }
}

function temporaryPcPartsFunc(modelType, modelName, modelNumber)
{
    var modelNameTemp = modelName.replace("Добавить", "")
    // var modelNameTemp = modelName
    switch(modelType)
    {
        case "pb":
        document.getElementById("currentConfigPb").innerHTML = modelNameTemp
        document.getElementById("currentConfigPb").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigPb").classList.remove("mm-3d-box-anim")
        },1000)
        for(let a = 1; a < 14; a++)
        {
            document.getElementById("pbButton" + a).disabled = false
            document.getElementById("pbButton" + a).innerHTML = "Добавить"
        }
        document.getElementById("pbButton" + modelNumber).disabled = true
        document.getElementById("pbButton" + modelNumber).innerHTML = "добавлено"
        idPb = abcArray[modelNumber]
        break;

        case "cpu":
        document.getElementById("currentConfigCPU").innerHTML = modelNameTemp
        document.getElementById("currentConfigCPU").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigCPU").classList.remove("mm-3d-box-anim")
        },1000)
        for(let a = 1; a < 11; a++)
        {
            document.getElementById("cpuButton" + a).disabled = false
            document.getElementById("cpuButton" + a).innerHTML = "Добавить"
        }
        document.getElementById("cpuButton" + modelNumber).disabled = true
        document.getElementById("cpuButton" + modelNumber).innerHTML = "добавлено"
        idCpu = abcArray[modelNumber]
        if(modelNumber === 1 || modelNumber === 2)
            cpuType = 0
        else if(modelNumber != 1 && modelNumber != 2)
            cpuType = 1
        break;

        case "ssd1":
        document.getElementById("currentConfigSSD1").innerHTML = modelNameTemp
        document.getElementById("currentConfigSSD1").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigSSD1").classList.remove("mm-3d-box-anim")
        },1000)
        for(let a = 1; a < 14; a++)
        {
            document.getElementById("ssd1Button" + a).disabled = false
            document.getElementById("ssd1Button" + a).innerHTML = "Добавить"
        }
        document.getElementById("ssd1Button" + modelNumber).disabled = true
        document.getElementById("ssd1Button" + modelNumber).innerHTML = "добавлено"
        idSsd1 = abcArray[modelNumber]
        break;

        case "ssd2":
        document.getElementById("currentConfigSSD2").innerHTML = modelNameTemp
        document.getElementById("currentConfigSSD2").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigSSD2").classList.remove("mm-3d-box-anim")
        },1000)
        for(let a = 1; a < 14; a++)
        {
            document.getElementById("ssd2Button" + a).disabled = false
            document.getElementById("ssd2Button" + a).innerHTML = "Добавить"
        }
        document.getElementById("ssd2Button" + modelNumber).disabled = true
        document.getElementById("ssd2Button" + modelNumber).innerHTML = "добавлено"
        idSsd2 = abcArray[modelNumber]
        break;

        case "hdd1":
        document.getElementById("currentConfigHDD1").innerHTML = modelNameTemp
        document.getElementById("currentConfigHDD1").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigHDD1").classList.remove("mm-3d-box-anim")
        },1000)
        for(let a = 1; a < 16; a++)
        {
            document.getElementById("hdd1Button" + a).disabled = false
            document.getElementById("hdd1Button" + a).innerHTML = "Добавить"
        }
        document.getElementById("hdd1Button" + modelNumber).disabled = true
        document.getElementById("hdd1Button" + modelNumber).innerHTML = "добавлено"
        idHdd1 = abcArray[modelNumber]
        break;

        case "hdd2":
        document.getElementById("currentConfigHDD2").innerHTML = modelNameTemp
        document.getElementById("currentConfigHDD2").classList.add("mm-3d-box-anim")
        setTimeout(() => {
            document.getElementById("currentConfigHDD2").classList.remove("mm-3d-box-anim")
        },1000)
        for(let a = 1; a < 16; a++)
        {
            document.getElementById("hdd2Button" + a).disabled = false
            document.getElementById("hdd2Button" + a).innerHTML = "Добавить"
        }
        document.getElementById("hdd2Button" + modelNumber).disabled = true
        document.getElementById("hdd2Button" + modelNumber).innerHTML = "добавлено"
        idHdd2 = abcArray[modelNumber]
        break;
    }
urlHandlingDone = false
}

function customIdHandler()
{
    idCase = idStringArray[0]
    idGpu = idStringArray[1]
    idMb = idStringArray[2]
    idCpuC = idStringArray[3]
    idRam = idStringArray[4]
    idPb = idStringArray[5]
    idCpu = idStringArray[6]
    idSsd1 = idStringArray[7]
    idSsd2 = idStringArray[8]
    idHdd1 = idStringArray[9]
    idHdd2 = idStringArray[10]
    idChair = idStringArray[11]
    idScreen = idStringArray[12]
    idKeyboard = idStringArray[13]
    idMouse = idStringArray[14]
    idMousepad = idStringArray[15]


    if( 
        idCase != "a" && idCase != "b" && idCase != "c" && idCase != "d" && idCase != "e" && idCase != "f" ||
        idGpu != "a" && idGpu != "b" && idGpu != "c" ||
        idMb != "a" && idMb != "b" && idMb != "c" && idMb != "d" && idMb != "e" ||
        idCpuC != "a" && idCpuC != "b" && idCpuC != "c" ||
        idRam != "a" && idRam != "b" && idRam != "c" && idRam != "d" ||
        idPb != "a" && idPb != "b" && idPb != "c" && idPb != "d" && idPb != "e" && idPb != "f" && idPb != "g" && idPb != "h" && idPb != "i" && idPb != "j" && idPb != "k" && idPb != "l" && idPb != "m" ||
        idCpu != "a" && idCpu != "b" && idCpu != "c" && idCpu != "d" && idCpu != "e" && idCpu != "f" && idCpu != "g" && idCpu != "h" && idCpu != "i" && idCpu != "j" ||
        idSsd1 != "a" && idSsd1 != "b" && idSsd1 != "c" && idSsd1 != "d" && idSsd1 != "e" && idSsd1 != "f" && idSsd1 != "g" && idSsd1 != "h" && idSsd1 != "i" && idSsd1 != "j" && idSsd1 != "k" && idSsd1 != "l" && idSsd1 != "m" ||
        idSsd2 != "a" && idSsd2 != "b" && idSsd2 != "c" && idSsd2 != "d" && idSsd2 != "e" && idSsd2 != "f" && idSsd2 != "g" && idSsd2 != "h" && idSsd2 != "i" && idSsd2 != "j" && idSsd2 != "k" && idSsd2 != "l" && idSsd2 != "m" ||
        idHdd1 != "a" && idHdd1 != "b" && idHdd1 != "c" && idHdd1 != "d" && idHdd1 != "e" && idHdd1 != "f" && idHdd1 != "g" && idHdd1 != "h" && idHdd1 != "i" && idHdd1 != "j" && idHdd1 != "k" && idHdd1 != "l" && idHdd1 != "m" && idHdd1 != "n" && idHdd1 != "o" ||
        idHdd2 != "a" && idHdd2 != "b" && idHdd2 != "c" && idHdd2 != "d" && idHdd2 != "e" && idHdd2 != "f" && idHdd2 != "g" && idHdd2 != "h" && idHdd2 != "i" && idHdd2 != "j" && idHdd2 != "k" && idHdd2 != "l" && idHdd2 != "m" && idHdd2 != "n" && idHdd2 != "o" ||
        idChair != "a" && idChair != "b" && idChair != "c" && idChair != "d" ||
        idScreen != "a" && idScreen != "b" && idScreen != "c" && idScreen != "d" && idScreen != "e" ||
        idKeyboard != "a" && idKeyboard != "b" && idKeyboard != "c" && idKeyboard != "d" && idKeyboard != "e" ||
        idMouse != "a" && idMouse != "b" && idMouse != "c" && idMouse != "d" && idMouse != "e" ||
        idMousepad != "a" && idMousepad != "b" && idMousepad != "c" && idMousepad != "d" && idMousepad != "e"
      )
    {
        idCase = "a"
        idGpu = "a"
        idMb = "a"
        idCpuC = "a"
        idRam = "a"
        idPb = "a"
        idCpu = "a"
        idSsd1 = "a"
        idSsd2 = "a"
        idHdd1 = "a"
        idHdd2 = "a"
        idChair = "a"
        idScreen = "a"
        idKeyboard = "a"
        idMouse = "a"
        idMousepad = "a"
        url.searchParams.set('id', 'aaaaaaaaaaaaaaaa')
        window.history.pushState({}, '', url)
    }
    if(idStringArray.length != 16)
    {
        idCase = "a"
        idGpu = "a"
        idMb = "a"
        idCpuC = "a"
        idRam = "a"
        idPb = "a"
        idCpu = "a"
        idSsd1 = "a"
        idSsd2 = "a"
        idHdd1 = "a"
        idHdd2 = "a"
        idChair = "a"
        idScreen = "a"
        idKeyboard = "a"
        idMouse = "a"
        idMousepad = "a"
        url.searchParams.set('id', 'aaaaaaaaaaaaaaaa')
        window.history.pushState({}, '', url)
    }

    // for(let a = 1; a < abcArray.length; a++)
    // {
    //     if(idCase === abcArray[a])
    //     {
    //         document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton" + a).parentNode.parentNode.innerText.replace(" добавлено", "").replace(" Добавить", "")
    //     }
    // }
}
function postLoadingHandler()
{
    if(idCase === "a")
    {
        caseTemp = case1
        scene.add(case1)
        caseType = 0
        document.getElementById("caseButton2").disabled = true
        document.getElementById("caseButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idCase === "b")
    {
        caseTemp = case2
        scene.add(case2)
        caseType = 2
        document.getElementById("caseButton1").disabled = true
        document.getElementById("caseButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idCase === "c")
    {
        caseTemp = case3
        scene.add(case3)
        caseType = 0
        document.getElementById("caseButton3").disabled = true
        document.getElementById("caseButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idCase === "d")
    {
        caseTemp = case4
        scene.add(case4)
        caseType = 1
        document.getElementById("caseButton5").disabled = true
        document.getElementById("caseButton5").innerHTML = "добавлено"
        document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton5").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idCase === "e")
    {
        caseTemp = case5
        scene.add(case5)
        caseType = 2
        document.getElementById("caseButton4").disabled = true
        document.getElementById("caseButton4").innerHTML = "добавлено"
        document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idCase === "f")
    {
        caseTemp = case6
        scene.add(case6)
        caseType = 2
        document.getElementById("caseButton6").disabled = true
        document.getElementById("caseButton6").innerHTML = "добавлено"
        document.getElementById("currentConfigCase").innerHTML = document.getElementById("caseButton6").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    if(idGpu === "a")
    {
        gpuTemp = gpu1
        scene.add(gpu1)
        gpuType = 0
        document.getElementById("gpuButton3").disabled = true
        document.getElementById("gpuButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigGpu").innerHTML = document.getElementById("gpuButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idGpu === "b")
    {
        gpuTemp = gpu2
        scene.add(gpu2)
        gpuType = 1
        document.getElementById("gpuButton2").disabled = true
        document.getElementById("gpuButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigGpu").innerHTML = document.getElementById("gpuButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idGpu === "c")
    {
        gpuTemp = gpu3
        scene.add(gpu3)
        gpuType = 1
        document.getElementById("gpuButton1").disabled = true
        document.getElementById("gpuButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigGpu").innerHTML = document.getElementById("gpuButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    if(idMb === "a")
    {
        mbTemp = mb1
        scene.add(mb1)
        mbType = 0
        document.getElementById("mbButton5").disabled = true
        document.getElementById("mbButton5").innerHTML = "добавлено"
        document.getElementById("currentConfigMb").innerHTML = document.getElementById("mbButton5").parentNode.parentNode.innerText.replace(" добавлено", "")

    }
    else if(idMb === "b")
    {
        mbTemp = mb2
        scene.add(mb2)
        mbType = 1
        document.getElementById("mbButton2").disabled = true
        document.getElementById("mbButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigMb").innerHTML = document.getElementById("mbButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMb === "c")
    {
        mbTemp = mb3
        scene.add(mb3)
        mbType = 1
        document.getElementById("mbButton1").disabled = true
        document.getElementById("mbButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigMb").innerHTML = document.getElementById("mbButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMb === "d")
    {
        mbTemp = mb4
        scene.add(mb4)
        mbType = 1
        document.getElementById("mbButton4").disabled = true
        document.getElementById("mbButton4").innerHTML = "добавлено"
        document.getElementById("currentConfigMb").innerHTML = document.getElementById("mbButton4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMb === "e")
    {
        mbTemp = mb5
        scene.add(mb5)
        mbType = 1
        document.getElementById("mbButton3").disabled = true
        document.getElementById("mbButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigMb").innerHTML = document.getElementById("mbButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    if(idCpuC === "a")
    {
        cpuCTemp = cpuC1
        scene.add(cpuC1)
        document.getElementById("cpuCButton3").disabled = true
        document.getElementById("cpuCButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigCpuC").innerHTML = document.getElementById("cpuCButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idCpuC === "b")
    {
        cpuCTemp = cpuC2
        scene.add(cpuC2)
        document.getElementById("cpuCButton2").disabled = true
        document.getElementById("cpuCButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigCpuC").innerHTML = document.getElementById("cpuCButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idCpuC === "c")
    {
        cpuCTemp = cpuC3
        scene.add(cpuC3)
        document.getElementById("cpuCButton1").disabled = true
        document.getElementById("cpuCButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigCpuC").innerHTML = document.getElementById("cpuCButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    if(idRam === "a")
    {
        ramTemp = ram1
        ram1clone1.visible = false
        ram1clone3.visible = false
        ramTempclone1 = ram1clone1
        ramTempclone2 = ram1clone2
        ramTempclone3 = ram1clone3
        scene.add(ramTempclone1)
        scene.add(ramTempclone2)
        scene.add(ramTempclone3)
        scene.add(ram1)
        document.getElementById("ramButton2x2").disabled = true
        document.getElementById("ramButton2x2").innerHTML = "добавлено"
        document.getElementById("currentConfigRam").innerHTML = document.getElementById("ramButton2x2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idRam === "b")
    {
        ramTemp = ram1
        ram1clone1.visible = true
        ram1clone3.visible = true
        ramTempclone1 = ram1clone1
        ramTempclone2 = ram1clone2
        ramTempclone3 = ram1clone3
        scene.add(ramTempclone1)
        scene.add(ramTempclone2)
        scene.add(ramTempclone3)
        scene.add(ram1)
        document.getElementById("ramButton2x4").disabled = true
        document.getElementById("ramButton2x4").innerHTML = "добавлено"
        document.getElementById("currentConfigRam").innerHTML = document.getElementById("ramButton2x4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idRam === "c")
    {
        ramTemp = ram2
        ram2clone1.visible = false
        ram2clone3.visible = false
        ramTempclone1 = ram2clone1
        ramTempclone2 = ram2clone2
        ramTempclone3 = ram2clone3
        scene.add(ramTempclone1)
        scene.add(ramTempclone2)
        scene.add(ramTempclone3)
        scene.add(ram2)
        document.getElementById("ramButton1x2").disabled = true
        document.getElementById("ramButton1x2").innerHTML = "добавлено"
        document.getElementById("currentConfigRam").innerHTML = document.getElementById("ramButton1x2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idRam === "d")
    {
        ramTemp = ram2
        ram2clone1.visible = true
        ram2clone3.visible = true
        ramTempclone1 = ram2clone1
        ramTempclone2 = ram2clone2
        ramTempclone3 = ram2clone3
        scene.add(ramTempclone1)
        scene.add(ramTempclone2)
        scene.add(ramTempclone3)
        scene.add(ram2)
        document.getElementById("ramButton1x4").disabled = true
        document.getElementById("ramButton1x4").innerHTML = "добавлено"
        document.getElementById("currentConfigRam").innerHTML = document.getElementById("ramButton1x4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    for(let a = 1; a < 14; a++)
    {
        if(idPb === abcArray[a])
        {
            document.getElementById("pbButton" + a).disabled = true
            document.getElementById("pbButton" + a).innerHTML = "добавлено"
            document.getElementById("currentConfigPb").innerHTML = document.getElementById("pbButton" + a).parentNode.parentNode.innerText.replace(" добавлено", "")
        }
    }
    for(let a = 1; a < 11; a++)
    {
        if(idCpu === abcArray[a])
        {
            document.getElementById("cpuButton" + a).disabled = true
            document.getElementById("cpuButton" + a).innerHTML = "добавлено"
            document.getElementById("currentConfigCPU").innerHTML = document.getElementById("cpuButton" + a).parentNode.parentNode.innerText.replace(" добавлено", "")
            if(a === 1 || a === 2)
                cpuType = 0
            else if(a != 1 && a != 2)
                cpuType = 1
        }
    }
    for(let a = 1; a < 13; a++)
    {
        if(idSsd1 === abcArray[a])
        {
            document.getElementById("ssd1Button" + a).disabled = true
            document.getElementById("ssd1Button" + a).innerHTML = "добавлено"
            document.getElementById("currentConfigSSD1").innerHTML = document.getElementById("ssd1Button" + a).parentNode.parentNode.innerText.replace(" добавлено", "")
        }
    }
    for(let a = 1; a < 14; a++)
    {
        if(idSsd2 === abcArray[a])
        {
            document.getElementById("ssd2Button" + a).disabled = true
            document.getElementById("ssd2Button" + a).innerHTML = "добавлено"
            document.getElementById("currentConfigSSD2").innerHTML = document.getElementById("ssd2Button" + a).parentNode.parentNode.innerText.replace(" добавлено", "")
        }
    }
    for(let a = 1; a < 15; a++)
    {
        if(idHdd1 === abcArray[a])
        {
            document.getElementById("hdd1Button" + a).disabled = true
            document.getElementById("hdd1Button" + a).innerHTML = "добавлено"
            document.getElementById("currentConfigHDD1").innerHTML = document.getElementById("hdd1Button" + a).parentNode.parentNode.innerText.replace(" добавлено", "")
        }
    }
    for(let a = 1; a < 16; a++)
    {
        if(idHdd2 === abcArray[a])
        {
            document.getElementById("hdd2Button" + a).disabled = true
            document.getElementById("hdd2Button" + a).innerHTML = "добавлено"
            document.getElementById("currentConfigHDD2").innerHTML = document.getElementById("hdd2Button" + a).parentNode.parentNode.innerText.replace(" добавлено", "")
        }
    }

    if(idChair === "a")
    {
        chairTemp = chair1
        chair1.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                chairParts.push(object.name)
            }
        })
        scene.add(chair1)
        chair2.children[0].position.x = -0.632
        chair2.children[0].position.z = -0.509
        chair2.children[0].rotation.set(0, 0.5, 0)
        chair3.children[0].position.x = -0.632
        chair3.children[0].position.z = -0.509
        chair3.children[0].rotation.set(0, 0.5, 0)
        document.getElementById("chairButton1").disabled = true
        document.getElementById("chairButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigChair").innerHTML = document.getElementById("chairButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idChair === "b")
    {
        chairTemp = chair1
        chair1.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                chairParts.push(object.name)
            }
        })
        scene.add(chair1)
        chair2.children[0].position.x = -0.632
        chair2.children[0].position.z = -0.509
        chair2.children[0].rotation.set(0, 0.5, 0)
        chair3.children[0].position.x = -0.632
        chair3.children[0].position.z = -0.509
        chair3.children[0].rotation.set(0, 0.5, 0)
        document.getElementById("chairButton2").disabled = true
        document.getElementById("chairButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigChair").innerHTML = document.getElementById("chairButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idChair === "c")
    {
        chairTemp = chair2
        chair2.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                chairParts.push(object.name)
            }
        })
        scene.add(chair2)
        chair1.children[0].position.x = -0.632
        chair1.children[0].position.z = -0.509
        chair1.children[0].rotation.set(0, 0.5, 0)
        document.getElementById("chairButton3").disabled = true
        document.getElementById("chairButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigChair").innerHTML = document.getElementById("chairButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idChair === "d")
    {
        chairTemp = chair3
        chair3.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                chairParts.push(object.name)
            }
        })
        scene.add(chair3)
        chair1.children[0].position.x = -0.632
        chair1.children[0].position.z = -0.509
        chair1.children[0].rotation.set(0, 0.5, 0)
        document.getElementById("chairButton4").disabled = true
        document.getElementById("chairButton4").innerHTML = "добавлено"
        document.getElementById("currentConfigChair").innerHTML = document.getElementById("chairButton4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    if(idScreen === "a")
    {
        screenTemp = screen1
        screen1.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                screenParts.push(object.name)
            }
        })
        scene.add(screen1)
        document.getElementById("screenButton1").disabled = true
        document.getElementById("screenButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigScreen").innerHTML = document.getElementById("screenButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idScreen === "b")
    {
        screenTemp = screen1
        screen1.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                screenParts.push(object.name)
            }
        })
        scene.add(screen1)
        document.getElementById("screenButton2").disabled = true
        document.getElementById("screenButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigScreen").innerHTML = document.getElementById("screenButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idScreen === "c")
    {
        screenTemp = screen2
        screen2.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                screenParts.push(object.name)
            }
        })
        scene.add(screen2)
        document.getElementById("screenButton3").disabled = true
        document.getElementById("screenButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigScreen").innerHTML = document.getElementById("screenButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idScreen === "d")
    {
        screenTemp = screen3
        screen3.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                screenParts.push(object.name)
            }
        })
        scene.add(screen3)
        document.getElementById("screenButton4").disabled = true
        document.getElementById("screenButton4").innerHTML = "добавлено"
        document.getElementById("currentConfigScreen").innerHTML = document.getElementById("screenButton4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idScreen === "e")
    {
        screenTemp = screen4
        screen4.traverse( function( object ) 
        {
            if ( object.isMesh ) 
            {
                screenParts.push(object.name)
            }
        })
        scene.add(screen4)
        document.getElementById("screenButton5").disabled = true
        document.getElementById("screenButton5").innerHTML = "добавлено"
        document.getElementById("currentConfigScreen").innerHTML = document.getElementById("screenButton5").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    if(idKeyboard === "a")
    {
        keyboardTemp = keyboard1
        scene.add(keyboard1)
        document.getElementById("keyboardButton1").disabled = true
        document.getElementById("keyboardButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigKeyboard").innerHTML = document.getElementById("keyboardButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idKeyboard === "b")
    {
        keyboardTemp = keyboard1
        scene.add(keyboard1)
        document.getElementById("keyboardButton2").disabled = true
        document.getElementById("keyboardButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigKeyboard").innerHTML = document.getElementById("keyboardButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idKeyboard === "c")
    {
        keyboardTemp = keyboard2
        scene.add(keyboard2)
        document.getElementById("keyboardButton3").disabled = true
        document.getElementById("keyboardButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigKeyboard").innerHTML = document.getElementById("keyboardButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idKeyboard === "d")
    {
        keyboardTemp = keyboard3
        scene.add(keyboard3)
        document.getElementById("keyboardButton4").disabled = true
        document.getElementById("keyboardButton4").innerHTML = "добавлено"
        document.getElementById("currentConfigKeyboard").innerHTML = document.getElementById("keyboardButton4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idKeyboard === "e")
    {
        keyboardTemp = keyboard4
        scene.add(keyboard4)
        document.getElementById("keyboardButton5").disabled = true
        document.getElementById("keyboardButton5").innerHTML = "добавлено"
        document.getElementById("currentConfigKeyboard").innerHTML = document.getElementById("keyboardButton5").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    if(idMouse === "a")
    {
        mouseTemp = mouse1
        scene.add(mouse1)
        document.getElementById("mouseButton1").disabled = true
        document.getElementById("mouseButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigMouse").innerHTML = document.getElementById("mouseButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMouse === "b")
    {
        mouseTemp = mouse1
        scene.add(mouse1)
        document.getElementById("mouseButton2").disabled = true
        document.getElementById("mouseButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigMouse").innerHTML = document.getElementById("mouseButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMouse === "c")
    {
        mouseTemp = mouse2
        scene.add(mouse2)
        document.getElementById("mouseButton3").disabled = true
        document.getElementById("mouseButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigMouse").innerHTML = document.getElementById("mouseButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMouse === "d")
    {
        mouseTemp = mouse3
        scene.add(mouse3)
        document.getElementById("mouseButton4").disabled = true
        document.getElementById("mouseButton4").innerHTML = "добавлено"
        document.getElementById("currentConfigMouse").innerHTML = document.getElementById("mouseButton4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMouse === "e")
    {
        mouseTemp = mouse4
        scene.add(mouse4)
        document.getElementById("mouseButton5").disabled = true
        document.getElementById("mouseButton5").innerHTML = "добавлено"
        document.getElementById("currentConfigMouse").innerHTML = document.getElementById("mouseButton5").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    if(idMousepad === "a")
    {
        mousepadTemp = mousepad1
        scene.add(mousepad1)
        document.getElementById("mousepadButton1").disabled = true
        document.getElementById("mousepadButton1").innerHTML = "добавлено"
        document.getElementById("currentConfigMousepad").innerHTML = document.getElementById("mousepadButton1").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMousepad === "b")
    {
        mousepadTemp = mousepad1
        scene.add(mousepad1)
        document.getElementById("mousepadButton2").disabled = true
        document.getElementById("mousepadButton2").innerHTML = "добавлено"
        document.getElementById("currentConfigMousepad").innerHTML = document.getElementById("mousepadButton2").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMousepad === "c")
    {
        mousepadTemp = mousepad2
        scene.add(mousepad2)
        document.getElementById("mousepadButton3").disabled = true
        document.getElementById("mousepadButton3").innerHTML = "добавлено"
        document.getElementById("currentConfigMousepad").innerHTML = document.getElementById("mousepadButton3").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMousepad === "d")
    {
        mousepadTemp = mousepad3
        scene.add(mousepad3)
        document.getElementById("mousepadButton4").disabled = true
        document.getElementById("mousepadButton4").innerHTML = "добавлено"
        document.getElementById("currentConfigMousepad").innerHTML = document.getElementById("mousepadButton4").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    else if(idMousepad === "e")
    {
        mousepadTemp = mousepad4
        scene.add(mousepad4)
        document.getElementById("mousepadButton5").disabled = true
        document.getElementById("mousepadButton5").innerHTML = "добавлено"
        document.getElementById("currentConfigMousepad").innerHTML = document.getElementById("mousepadButton5").parentNode.parentNode.innerText.replace(" добавлено", "")
    }
    partsHandlingDone = false
    //compatibilityCaseHandlingDone = false
    //compatibilityMbHandlingDone = false
    cpuCHandlingDone = false
}

function compatibilityTurnOn()
{
    document.getElementById("compatibility3Dconfig").disabled = true
    setTimeout(() => 
    {
        document.getElementById("compatibility3Dconfig").disabled = false
    },1000)
    compatibilityCaseHandlingDone = false
    compatibilityMbHandlingDone = false
    // cpuCHandlingDone = false
}

function screenResizeHandler() 
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)

    composer.setSize(sizes.width, sizes.height)
    composer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
}


//PC parts loaders
//Case
function caseLoader()
{
    //case1
    gltfLoader.load(
    './release/pc/Case/Mistral_Micro_T3B_Main_divided.gltf',
    (gltf) =>
    {
        case1 = gltf.scene
        
    })
    //case2
    gltfLoader.load(
    './release/pc/Case/JONSBO_Jonsplus_i400-G_Silver.gltf',
    (gltf) =>
    {
        case2 = gltf.scene
        
    })
    //case3
    gltfLoader.load(
    './release/pc/Case/1STPLAYER_INFINITE_SPACE_IS6.gltf',
    (gltf) =>
    {
        case3 = gltf.scene
    })
    //case4
    gltfLoader.load(
    './release/pc/Case/Fractal_torrent_lgbt 2.gltf',
    (gltf) =>
    {
        case4 = gltf.scene
    })
    //case5
    gltfLoader.load(
    './release/pc/Case/MagniumGearNEO.gltf',
    (gltf) =>
    {
        case5 = gltf.scene
    })
    //case6
    gltfLoader.load(
    './release/pc/Case/PHANTEKS_Eclipse_P500A.gltf',
    (gltf) =>
    {
        case6 = gltf.scene
    })
}
//GPU
function gpuLoader()
{
    //gpu1
    gltfLoader.load(
    './release/pc/GPU/NVIDIA RTX 3060 Ti FE.gltf',
    (gltf) =>
    {
        gpu1 = gltf.scene
    })
    //gpu2
    gltfLoader.load(
    './release/pc/GPU/ASUS_TUF_GAMING_RTX_4080.gltf',
    (gltf) =>
    {
        gpu2 = gltf.scene
    })
    //gpu3
    gltfLoader.load(
    './release/pc/GPU/Palit GeForce RTX 4090 GameRock.gltf',
    (gltf) =>
    {
        gpu3 = gltf.scene
    })
}
//MB
function mbLoader()
{
    //mb1
    gltfLoader.load(
    './release/pc/MB/ASROCK B660M PRO RS.gltf',
    (gltf) =>
    {
        mb1 = gltf.scene
    })
    //mb2
    gltfLoader.load(
    './release/pc/MB/asus_prime_z790_a-wifi.gltf',
    (gltf) =>
    {
        mb2 = gltf.scene
    })
    //mb3
    gltfLoader.load(
    './release/pc/MB/ASUS_ROG_MAXIMUS_Z790_EXTREME.gltf',
    (gltf) =>
    {
        mb3 = gltf.scene
    })
    //mb4
    gltfLoader.load(
    './release/pc/MB/GIGABYTE_Z790_AERO_G.gltf',
    (gltf) =>
    {
        mb4 = gltf.scene
    })
    //mb5
    gltfLoader.load(
    './release/pc/MB/Gigabyte_Z790_Aorus_Master.gltf',
    (gltf) =>
    {
        mb5 = gltf.scene
    })
}
//CPU Cooling
function cpuCLoader()
{
    //cpuC1
    gltfLoader.load(
    './release/pc/CPU cooling/Alseye_M120D_PLUS.gltf',
    (gltf) =>
    {
        cpuC1 = gltf.scene
    })
    //cpuC2
    gltfLoader.load(
    './release/pc/CPU water cooling/Lumen_S24_RGB/Lumen_S24_RGB.gltf',
    (gltf) =>
    {
        cpuC2 = gltf.scene
    })
    //cpuC3
    gltfLoader.load(
    './release/pc/CPU water cooling/NZXT_Kraken_Z63_RGB/NZXT_Kraken_Z63_RGB.gltf',
    (gltf) =>
    {
        cpuC3 = gltf.scene
    })
}

//RAM
function ramLoader()
{
    //RAM1
    gltfLoader.load(
    './release/pc/RAM/tforceDelta.gltf',
    (gltf) =>
    {
        ram1 = gltf.scene
        ram1clone1 = ram1.clone()
        // ram1clone1.visible = false
        ram1clone2 = ram1.clone()
        ram1clone3 = ram1.clone()
        // ram1clone3.visible = false
        // ramTempclone1 = ram1clone1
        // ramTempclone2 = ram1clone2
        // ramTempclone3 = ram1clone3
    })
    //RAM2
    gltfLoader.load(
    './release/pc/RAM/furyBeast.gltf',
    (gltf) =>
    {
        ram2 = gltf.scene
        ram2clone1 = ram2.clone()
        // ram2clone1.visible = false
        ram2clone2 = ram2.clone()
        ram2clone3 = ram2.clone()
        // ram2clone3.visible = false
    })
}

//Accessories loaders
function chairLoader()
{
    //chair1
    gltfLoader.load(
    './release/accessories/chair/COOLER_MASTER_CALIBER_R2.gltf',
    (gltf) =>
    {
        chair1 = gltf.scene
    })
    //chair2
    gltfLoader.load(
    './release/accessories/chair/Asus_ROG_Chariot_Gaming_Chair_RGB.gltf',
    (gltf) =>
    {
        chair2 = gltf.scene
        chair2.getObjectByName('Cube003_7').material.color = new THREE.Color(0x040404)
        chair2.getObjectByName('Cube003_8').material.color = new THREE.Color(0x330066)
    })
    //chair3
    gltfLoader.load(
    './release/accessories/chair/Noblechairs_ICON.gltf',
    (gltf) =>
    {
        chair3 = gltf.scene
    })
}
function screenLoader()
{
    //screen1
    gltfLoader.load(
    './release/accessories/screen/Acer_CB342CKC.gltf',
    (gltf) =>
    {
        screen1 = gltf.scene
    })
    //screen2
    gltfLoader.load(
    './release/accessories/screen/AOC 24G2SPU img.gltf',
    (gltf) =>
    {
        screen2 = gltf.scene
    })
    //screen3
    gltfLoader.load(
    './release/accessories/screen/ASUS_ROG_Swift_PG32UQX.gltf',
    (gltf) =>
    {
        screen3 = gltf.scene
    })
    //screen4
    gltfLoader.load(
    './release/accessories/screen/Samsung_Odyssey_G9_img.gltf',
    (gltf) =>
    {
        screen4 = gltf.scene
    })
}
function keyboardLoader()
{
    //keyboard1
    gltfLoader.load(
    './release/accessories/keyboard/AKKO 3084B Plus Jelly.gltf',
    (gltf) =>
    {
        keyboard1 = gltf.scene
    })
    //keyboard2
    gltfLoader.load(
    './release/accessories/keyboard/Logitech G915 TKL.gltf',
    (gltf) =>
    {
        keyboard2 = gltf.scene
    })
    //keyboard3
    gltfLoader.load(
    './release/accessories/keyboard/Logitech_G_Pro.gltf',
    (gltf) =>
    {
        keyboard3 = gltf.scene
    })
    //keyboard4
    gltfLoader.load(
    './release/accessories/keyboard/RazerDSV2P.gltf',
    (gltf) =>
    {
        keyboard4 = gltf.scene
    })
}
function mouseLoader()
{
    //mouse1
    gltfLoader.load(
    './release/accessories/mouse/Logitech PRO Х Superlight Wireless.gltf',
    (gltf) =>
    {
        mouse1 = gltf.scene
    })
    //mouse2
    gltfLoader.load(
    './release/accessories/mouse/Microsoft_Intellimouse_Classic.gltf',
    (gltf) =>
    {
        mouse2 = gltf.scene
    })
    //mouse3
    gltfLoader.load(
    './release/accessories/mouse/Xtrfy M4 RGB.gltf',
    (gltf) =>
    {
        mouse3 = gltf.scene
    })
    //mouse4
    gltfLoader.load(
    './release/accessories/mouse/Razer_Basilisk_Ultimate.gltf',
    (gltf) =>
    {
        mouse4 = gltf.scene
    })
}
function mousepadLoader()
{
    //mousepad1
    gltfLoader.load(
    './release/accessories/mousepad/Cooler_Master_Gaming_Masteraccessory_MP750_Size_M.gltf',
    (gltf) =>
    {
        mousepad1 = gltf.scene
    })
    //mousepad2
    gltfLoader.load(
    './release/accessories/mousepad/Cooler_Master_XL_Size.gltf',
    (gltf) =>
    {
        mousepad2 = gltf.scene
    })
    //mousepad3
    gltfLoader.load(
    './release/accessories/mousepad/Razer_Goliathus_Extended_Chroma_Mercury_White.gltf',
    (gltf) =>
    {
        mousepad3 = gltf.scene
    })
    //mousepad4
    gltfLoader.load(
    './release/accessories/mousepad/Razer_Strider_Chroma.gltf',
    (gltf) =>
    {
        mousepad4 = gltf.scene
    })
}

//Rooms
function roomLoader()
{
    //room1
    gltfLoader.load(
    './3Dmodels/room_1-5.gltf',
    (gltf) =>
    {
        room1 = gltf.scene
        room1.position.set(-0.8,-1.44,1)
        scene.add(gltf.scene)
        ps5loaded = true
        // const image = new Image()

        // const texture = new THREE.Texture(image)
        // image.addEventListener('load', () =>
        // {
        //     texture.needsUpdate = true
        // })
        // image.src = '/textures/texture3.png'
        // room1.getObjectByName( 'Plane014' ).material = new THREE.MeshPhysicalMaterial({ map: texture })
        // room1.getObjectByName( 'Plane014' ).material.color = new THREE.Color("rgb(120, 120, 120)")
    },
    (progress) =>
    {

    },
    (error) =>
    {
        //console.log('error')
    })
}